import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal, Nav, ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import { Stack, Switch, Tooltip, Checkbox } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import { DataGrid } from "@mui/x-data-grid";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import ReplayIcon from "@mui/icons-material/Replay";
import { nanoid } from "nanoid";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import ColumnResizer from "react-table-column-resizer";
import "styles/catalog.css";
import { getProductType } from "../../redux/handlers/product/getProductType.handler";
import { getCategory } from "../../redux/handlers/product/getCategory.handler";
import { getSubCategory } from "../../redux/handlers/product/getSubCategory.handler";
import { allBrand } from "../../redux/handlers/manage/allBrand.handler";
import { getDataclbookOne } from "../../redux/handlers/manage/getDataclbookOne.handler";
import { allCatalog } from "../../redux/handlers/manage/allCatalog.handler";
import { getProduct } from "../../redux/handlers/manage/getProduct.handler";
import { getCatalogById } from "../../redux/handlers/manage/getCatalogById.handler";
import { updateStatusCatalog, clearupdateStatusCatalog } from "../../redux/handlers/manage/updateStatusCatalog.handler";
import { updateStatusNew, clearupdateStatusNew } from "../../redux/handlers/manage/updateStatusNew.handler";
import { updateStatusRecom, clearupdateStatusRecom } from "../../redux/handlers/manage/updateStatusRecom.handler";
import { getPromotion } from "../../redux/handlers/manage/getPromotion.handler";
import { getAllMstUnit } from "../../redux/handlers/product/getAllMstUnit.handler";
import { getMstBrandCate } from "../../redux/handlers/master/getMstBrandCate.handler";
import { getAllMstBrand } from "../../redux/handlers/master/getAllMstBrand.handler";
import { createCatalog, clearcreateCatalog } from "../../redux/handlers/manage/createCatalog.handler";
import { updateCatalog, clearupdateCatalog } from "../../redux/handlers/manage/updateCatalog.handler";
import { deleteCatalog, cleardeleteCatalog } from "../../redux/handlers/manage/deleteCatalog.handler";
import { deleteOpenCatalog, cleardeleteOpenCatalog } from "../../redux/handlers/manage/deleteOpenCatalog.handler";
import { updateDetailCatalog, clearupdateDetailCatalog } from "../../redux/handlers/manage/updateDetailCatalog.handler";
import { getCatalogSummary } from "../../redux/handlers/master/getCatalogSummary.handler";
import { useReactToPrint } from "react-to-print";
import DownloadFile from "utils/DownloadFile";
import { http } from "utils/http";
import { endPoint } from "constants/server/api";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import NotoSansLao from "fonts/NotoSansLaoSemiCondensedRegular.ttf";
import NotoSansLaoBold from "fonts/NotoSansLaoSemiCondensedBold.ttf";
import sarabun from "fonts/SarabunRegular.ttf";
import sarabunBold from "fonts/SarabunSemiBold.ttf";
import phetsarath from "fonts/PhetsarathRegular.ttf";
import phetsarathBold from "fonts/PhetsarathBold.ttf";
import { saveAs } from "file-saver";
import { Buffer } from "buffer";
import { use } from "react";
// โหลดฟอนต์ภาษาไทย
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
// โหลดฟอนต์ภาษาลาว
Font.register({
    family: "NotoSansLao",
    fonts: [
        {
            src: NotoSansLao
        },
        {
            src: NotoSansLaoBold,
            fontWeight: "bold"
        }
    ]
});
var CatalogWholesaleTierPrices = function(param) {
    var detail = param.detail;
    var levels = [
        1,
        2,
        3,
        4
    ].map(function(level) {
        var field = level === 1 ? "cl_detail_wholesale" : "cl_detail_wholesale_level".concat(level);
        var _detail_field, _ref;
        var exVat = (_ref = (_detail_field = detail[field]) !== null && _detail_field !== void 0 ? _detail_field : detail.cl_detail_wholesale) !== null && _ref !== void 0 ? _ref : 0;
        var computedInVat = Number((Number(exVat || 0) * 1.1).toFixed(2));
        var _detail_cl_detail_wholesalevat;
        var inVat = level === 1 ? (_detail_cl_detail_wholesalevat = detail.cl_detail_wholesalevat) !== null && _detail_cl_detail_wholesalevat !== void 0 ? _detail_cl_detail_wholesalevat : computedInVat : computedInVat;
        return {
            level: level,
            exVat: exVat,
            inVat: inVat
        };
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "catalog-wholesale-tier-grid",
        children: levels.map(function(param) {
            var level = param.level, exVat = param.exVat, inVat = param.inVat;
            return /*#__PURE__*/ _jsxs("div", {
                className: "catalog-wholesale-tier",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "catalog-wholesale-tier-heading",
                        children: [
                            "Level ",
                            level
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "catalog-wholesale-tier-price",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "Ex VAT"
                            }),
                            /*#__PURE__*/ _jsx("strong", {
                                children: NumberFormat(exVat, 2)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "catalog-wholesale-tier-price",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: "In VAT"
                            }),
                            /*#__PURE__*/ _jsx("strong", {
                                children: NumberFormat(inVat, 2)
                            })
                        ]
                    })
                ]
            }, level);
        })
    });
};
export function Catalog() {
    var _location_state;
    if (typeof window !== "undefined" && !window.Buffer) {
        window.Buffer = Buffer;
    }
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var navigate = useNavigate();
    var location = useLocation();
    var restoredCatalogListState = ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.catalogListState) || {};
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState({}), 2), dataClbook = _useState[0], setDataClbook = _useState[1];
    var _useState1 = _sliced_to_array(useState(restoredCatalogListState.filterText || ""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(restoredCatalogListState.appliedSearchText || ""), 2), appliedSearchText = _useState2[0], setAppliedSearchText = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), modelText = _useState3[0], setmodelText = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _restoredCatalogListState_tabStatus;
    var _useState6 = _sliced_to_array(useState((_restoredCatalogListState_tabStatus = restoredCatalogListState.tabStatus) !== null && _restoredCatalogListState_tabStatus !== void 0 ? _restoredCatalogListState_tabStatus : 0), 2), tabStatus = _useState6[0], setTabStatus = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), rowData = _useState7[0], setRowData = _useState7[1];
    var _useState8 = _sliced_to_array(useState(restoredCatalogListState.pageId || 1), 2), pageId = _useState8[0], setPageId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(restoredCatalogListState.pageSize || 10), 2), pageSize = _useState9[0], setPageSize = _useState9[1];
    var _useState10 = _sliced_to_array(useState(1), 2), totalPage = _useState10[0], setTotalPage = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), totalAmount = _useState11[0], setTotalAmount = _useState11[1];
    var _useState12 = _sliced_to_array(useState(false), 2), isPrintingPdf = _useState12[0], setIsPrintingPdf = _useState12[1];
    var catalogCacheRef = useRef(new Map());
    var catalogRequestKeyRef = useRef("");
    var subCategoryRequestKeyRef = useRef("");
    var printRowsCacheRef = useRef(new Map());
    var _restoredCatalogListState_tabPdType;
    var _useState13 = _sliced_to_array(useState((_restoredCatalogListState_tabPdType = restoredCatalogListState.tabPdType) !== null && _restoredCatalogListState_tabPdType !== void 0 ? _restoredCatalogListState_tabPdType : 0), 2), tabPdType = _useState13[0], setTabPdType = _useState13[1];
    var _restoredCatalogListState_tabCateType;
    var _useState14 = _sliced_to_array(useState((_restoredCatalogListState_tabCateType = restoredCatalogListState.tabCateType) !== null && _restoredCatalogListState_tabCateType !== void 0 ? _restoredCatalogListState_tabCateType : 0), 2), tabCateType = _useState14[0], setTabCateType = _useState14[1];
    var _restoredCatalogListState_tabSubCateType;
    var _useState15 = _sliced_to_array(useState((_restoredCatalogListState_tabSubCateType = restoredCatalogListState.tabSubCateType) !== null && _restoredCatalogListState_tabSubCateType !== void 0 ? _restoredCatalogListState_tabSubCateType : 0), 2), tabSubCateType = _useState15[0], setTabSubCateType = _useState15[1];
    var _restoredCatalogListState_tabBrandType;
    var _useState16 = _sliced_to_array(useState((_restoredCatalogListState_tabBrandType = restoredCatalogListState.tabBrandType) !== null && _restoredCatalogListState_tabBrandType !== void 0 ? _restoredCatalogListState_tabBrandType : 0), 2), tabBrandType = _useState16[0], setTabBrandType = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), brandType = _useState17[0], setBrandType = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), typeCategory = _useState18[0], setTypeCategory = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), typeSubCategory = _useState19[0], setTypeSubCategory = _useState19[1];
    var _useState20 = _sliced_to_array(useState([]), 2), productType = _useState20[0], setProductType = _useState20[1];
    var _useState21 = _sliced_to_array(useState({}), 2), dataForSearch = _useState21[0], setDataForSearch = _useState21[1];
    var _useState22 = _sliced_to_array(useState([]), 2), summary = _useState22[0], setSummary = _useState22[1];
    var _useState23 = _sliced_to_array(useState({}), 2), brandData = _useState23[0], setBrandData = _useState23[1];
    var _useState24 = _sliced_to_array(useState({}), 2), producttypeData = _useState24[0], setProducttypeData = _useState24[1];
    var _useState25 = _sliced_to_array(useState({}), 2), categoryData = _useState25[0], setCategoryData = _useState25[1];
    var _useState26 = _sliced_to_array(useState({}), 2), categorysubData = _useState26[0], setCategorysubData = _useState26[1];
    var normalizeCatalogPayload = function() {
        var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return Object.keys(payload).sort().reduce(function(acc, key) {
            var value = payload[key];
            var isOptionalFilter = key !== "bookid";
            if (isOptionalFilter && (value === undefined || value === null || value === "" || Number(value) === 0)) {
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
    };
    var getCatalogCacheKey = function() {
        var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return JSON.stringify(Object.keys(payload).sort().reduce(function(acc, key) {
            acc[key] = payload[key];
            return acc;
        }, {}));
    };
    var fetchCatalog = function(payload) {
        var _payload_searchtext;
        var normalizedPayload = normalizeCatalogPayload(_object_spread_props(_object_spread({}, payload), {
            searchtext: (_payload_searchtext = payload.searchtext) !== null && _payload_searchtext !== void 0 ? _payload_searchtext : appliedSearchText,
            pageId: pageId,
            pageSize: pageSize
        }));
        var cacheKey = getCatalogCacheKey(normalizedPayload);
        setDataForSearch(normalizedPayload);
        catalogRequestKeyRef.current = cacheKey;
        if (catalogCacheRef.current.has(cacheKey)) {
            var _cached_pagination, _cached_pagination1, _cached_data;
            var cached = catalogCacheRef.current.get(cacheKey);
            setRowData((cached === null || cached === void 0 ? void 0 : cached.data) || []);
            setTotalPage((cached === null || cached === void 0 ? void 0 : (_cached_pagination = cached.pagination) === null || _cached_pagination === void 0 ? void 0 : _cached_pagination.totalPage) || 1);
            setTotalAmount((cached === null || cached === void 0 ? void 0 : (_cached_pagination1 = cached.pagination) === null || _cached_pagination1 === void 0 ? void 0 : _cached_pagination1.total) || (cached === null || cached === void 0 ? void 0 : (_cached_data = cached.data) === null || _cached_data === void 0 ? void 0 : _cached_data.length) || 0);
            return;
        }
        dispatch(allCatalog(normalizedPayload, {
            modalObj: modalObj,
            setModalObj: setModalObj,
            requestKey: cacheKey
        }));
    };
    var handleTabStatusSelect = function(selectedKey) {
        if (String(tabStatus) === String(selectedKey)) return;
        var nextStatus = selectedKey !== null && selectedKey !== void 0 ? selectedKey : 0;
        setPageId(1);
        setTabStatus(nextStatus);
        if (String(nextStatus) !== "4") {
            setTabBrandType(0);
        }
        if (String(nextStatus) !== "5") {
            setTabPdType(0);
            setTabCateType(0);
            setTabSubCateType(0);
        }
    };
    var handleBrandTabSelect = function(selectedKey) {
        if (String(tabBrandType) === String(selectedKey)) return;
        setPageId(1);
        setTabBrandType(selectedKey !== null && selectedKey !== void 0 ? selectedKey : 0);
    };
    var handleProductTypeTabSelect = function(selectedKey) {
        if (String(tabPdType) === String(selectedKey)) return;
        setPageId(1);
        setTabPdType(selectedKey !== null && selectedKey !== void 0 ? selectedKey : 0);
        setTabCateType(0);
        setTabSubCateType(0);
        setTypeCategory([]);
        setTypeSubCategory([]);
    };
    var handleCategoryTabSelect = function(selectedKey) {
        if (String(tabCateType) === String(selectedKey)) return;
        setPageId(1);
        setTabCateType(selectedKey !== null && selectedKey !== void 0 ? selectedKey : 0);
        setTabSubCateType(0);
        setTypeSubCategory([]);
    };
    var handleSubCategoryTabSelect = function(selectedKey) {
        if (String(tabSubCateType) === String(selectedKey)) return;
        setPageId(1);
        setTabSubCateType(selectedKey !== null && selectedKey !== void 0 ? selectedKey : 0);
    };
    useEffect(function() {
        dispatch(clearupdateStatusCatalog());
        dispatch(clearupdateStatusNew());
        dispatch(clearupdateStatusRecom());
        return function() {
            dispatch(clearupdateStatusCatalog());
            dispatch(clearupdateStatusNew());
            dispatch(clearupdateStatusRecom());
        };
    }, [
        dispatch
    ]);
    var _useState27 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState27[0], setModalDel = _useState27[1];
    var _useState28 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDelOpen = _useState28[0], setModalDelOpen = _useState28[1];
    var _useState29 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalUpdateDetail = _useState29[0], setModalUpdateDetail = _useState29[1];
    var _useState30 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalStatus = _useState30[0], setModalStatus = _useState30[1];
    var getProductTypeReducer = useAppSelector(function(state) {
        return state.getProductTypeReducer;
    });
    var getCategoryReducer = useAppSelector(function(state) {
        return state.getCategoryReducer;
    });
    var getSubCategoryReducer = useAppSelector(function(state) {
        return state.getSubCategoryReducer;
    });
    var getMstBrandCateReducer = useAppSelector(function(state) {
        return state.getMstBrandCateReducer;
    });
    var getDataclbookOneReducer = useAppSelector(function(state) {
        return state.getDataclbookOneReducer;
    });
    var getCatalogSummaryReducer = useAppSelector(function(state) {
        return state.getCatalogSummaryReducer;
    });
    var allCatalogReducer = useAppSelector(function(state) {
        return state.allCatalogReducer;
    });
    useEffect(function() {
        if (dataID) {
            dispatch(getDataclbookOne({
                id: parseInt(dataID)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(getCatalogSummary({
                bookid: parseInt(dataID)
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        dataID
    ]);
    useEffect(function() {
        setIsLoading(getDataclbookOneReducer.isFetching || getCatalogSummaryReducer.isFetching);
        if (getDataclbookOneReducer.data) {
            setDataClbook(getDataclbookOneReducer.data.data);
        }
        if (getCatalogSummaryReducer.data) {
            setSummary(getCatalogSummaryReducer.data.data);
        }
    }, [
        getDataclbookOneReducer,
        getCatalogSummaryReducer
    ]);
    useEffect(function() {
        if (tabStatus == 0) {
            var data = {
                bookid: parseInt(dataID)
            };
            fetchCatalog(data);
        } else if (tabStatus == 1) {
            var data1 = {
                bookid: parseInt(dataID),
                statusnew: 1
            };
            fetchCatalog(data1);
        } else if (tabStatus == 2) {
            var data2 = {
                bookid: parseInt(dataID),
                statusrecom: 1
            };
            fetchCatalog(data2);
        } else if (tabStatus == 3) {
            var data3 = {
                bookid: parseInt(dataID),
                promotion: 1
            };
            fetchCatalog(data3);
        } else if (tabStatus == 4) {
            if (!brandType.length) {
                dispatch(getMstBrandCate(parseInt(dataID), {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
            var data4 = {
                bookid: parseInt(dataID),
                brandid: parseInt(tabBrandType)
            };
            fetchCatalog(data4);
        } else if (tabStatus == 5) {
            var data5 = {
                bookid: parseInt(dataID),
                producttypeid: parseInt(tabPdType),
                categoryid: parseInt(tabCateType),
                categorysubid: parseInt(tabSubCateType)
            };
            fetchCatalog(data5);
            if (!productType.length) {
                dispatch(getProductType());
            }
            if (tabPdType != 0 && !typeCategory.length) {
                dispatch(getCategory(parseInt(tabPdType)));
            }
            if (tabPdType != 0 && tabCateType != 0) {
                var subCategoryRequestKey = "".concat(tabPdType, "-").concat(tabCateType);
                if (subCategoryRequestKeyRef.current !== subCategoryRequestKey) {
                    subCategoryRequestKeyRef.current = subCategoryRequestKey;
                    dispatch(getSubCategory(parseInt(tabPdType), parseInt(tabCateType)));
                }
            }
        } else if (tabStatus == 6) {
            var data6 = {
                bookid: parseInt(dataID),
                statusdelete: 1
            };
            fetchCatalog(data6);
        } else {}
    }, [
        tabStatus,
        tabPdType,
        tabCateType,
        tabSubCateType,
        tabBrandType,
        appliedSearchText,
        pageId,
        pageSize
    ]);
    useEffect(function() {
        setIsLoading(allCatalogReducer.isFetching);
        if (allCatalogReducer.data) {
            var responseData = allCatalogReducer.data.data;
            var data = Array.isArray(responseData) ? responseData : (responseData === null || responseData === void 0 ? void 0 : responseData.data) || [];
            var pagination = Array.isArray(responseData) ? {} : (responseData === null || responseData === void 0 ? void 0 : responseData.pagination) || {};
            if (allCatalogReducer.requestKey && allCatalogReducer.requestKey !== catalogRequestKeyRef.current) {
                return;
            }
            if (catalogRequestKeyRef.current) {
                catalogCacheRef.current.set(catalogRequestKeyRef.current, {
                    data: data,
                    pagination: pagination
                });
            }
            setRowData(data);
            setTotalPage(pagination.totalPage || 1);
            setTotalAmount(pagination.total || data.length || 0);
        // setFilteredItems(data);
        }
        if (tabStatus == 4) {
            if (getMstBrandCateReducer.data) {
                setBrandType(getMstBrandCateReducer.data.data);
            }
        }
        if (tabStatus == 5) {
            if (getProductTypeReducer.data) {
                setProductType(getProductTypeReducer.data.data);
            }
            if (tabPdType != 0) {
                if (getCategoryReducer.data) {
                    setTypeCategory(getCategoryReducer.data.data);
                }
                if (tabCateType != 0) {
                    if (getSubCategoryReducer.data) {
                        setTypeSubCategory(getSubCategoryReducer.data.data);
                    }
                }
            }
        }
    }, [
        allCatalogReducer,
        getProductTypeReducer,
        getCategoryReducer,
        getSubCategoryReducer,
        getMstBrandCateReducer,
        tabStatus,
        tabPdType,
        tabCateType
    ]);
    var loadSearchPin = function() {
        setPageId(1);
        setAppliedSearchText(filterText.trim());
    };
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        documentTitle: "แคตตาล็อกสินค้า".concat(moment().format("DDMMYYYYHHmmss")),
        content: function() {
            return componentRef.current;
        }
    });
    var getCatalogPrintTypeLabel = function(printType) {
        return printType === "th" ? "TH" : "LAOS";
    };
    var getCatalogShopTypeLabel = function(shopType) {
        return Number(shopType) === 0 ? "ALL" : Number(shopType) === 3 ? "MT" : "RT/WT";
    };
    var catalogBookHeaderText = useMemo(function() {
        var bookParts = [
            dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_code,
            dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_name
        ].filter(function(value) {
            return value;
        });
        if (!bookParts.length) {
            return "";
        }
        return "".concat(bookParts.join(" "), " (").concat(getCatalogShopTypeLabel(dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_typeshop), ")");
    }, [
        dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_code,
        dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_name,
        dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_typeshop
    ]);
    var getCatalogPdfFileName = function(printType) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var fileNameParts = _to_consumable_array(options.isPromotion ? [
            "PROMOTION"
        ] : []).concat([
            (dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_code) || "",
            (dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_name) || "",
            getCatalogShopTypeLabel(dataClbook === null || dataClbook === void 0 ? void 0 : dataClbook.cl_book_typeshop)
        ], _to_consumable_array(options.priceLevel ? [
            "LEVEL-".concat(options.priceLevel)
        ] : []), [
            getCatalogPrintTypeLabel(printType)
        ]).filter(function(value) {
            return value !== "";
        });
        var rawFileName = fileNameParts.join("-");
        var safeFileName = rawFileName.replace(/[\\/:*?"<>|]/g, "-");
        return "".concat(safeFileName, ".pdf");
    };
    var currentCatalogListState = useMemo(function() {
        return {
            tabStatus: tabStatus,
            tabPdType: tabPdType,
            tabCateType: tabCateType,
            tabSubCateType: tabSubCateType,
            tabBrandType: tabBrandType,
            filterText: filterText,
            appliedSearchText: appliedSearchText,
            pageId: pageId,
            pageSize: pageSize
        };
    }, [
        tabStatus,
        tabPdType,
        tabCateType,
        tabSubCateType,
        tabBrandType,
        filterText,
        appliedSearchText,
        pageId,
        pageSize
    ]);
    var createCatalogPdfBlob = function() {
        var _ref = _async_to_generator(function(even) {
            var options, sourceRows, printRowData, headerTitle;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                sourceRows = options.normalizedRowData ? options.rowData || rowData : normalizeCatalogPdfRows(options.rowData || rowData);
                printRowData = options.priceLevel ? applyCatalogPrintPriceLevel(sourceRows, options.priceLevel) : sourceRows;
                headerTitle = options.headerTitle || "";
                if (even == "th") {
                    return [
                        2,
                        pdf(/*#__PURE__*/ _jsx(CatalogDocument, {
                            bookInfo: dataClbook,
                            rowData: printRowData,
                            headerTitle: headerTitle
                        })).toBlob()
                    ];
                }
                return [
                    2,
                    pdf(/*#__PURE__*/ _jsx(CatalogDocumentLao, {
                        bookInfo: dataClbook,
                        rowData: printRowData,
                        headerTitle: headerTitle
                    })).toBlob()
                ];
            });
        });
        return function createCatalogPdfBlob(even) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchCatalogRowsForPrint = function() {
        var _ref = _async_to_generator(function() {
            var options, _result_data, accessToken, printPayload, printCacheKey, result, responseData, rows, normalizedRows;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                        accessToken = localStorage.getItem("accessToken");
                        printPayload = normalizeCatalogPayload(_object_spread_props(_object_spread({}, options.payload || dataForSearch), {
                            pageId: 1,
                            pageSize: options.pageSize || Math.max(Number(totalAmount || 0), 100000)
                        }));
                        printCacheKey = getCatalogCacheKey(printPayload);
                        if (printRowsCacheRef.current.has(printCacheKey)) {
                            return [
                                2,
                                printRowsCacheRef.current.get(printCacheKey)
                            ];
                        }
                        return [
                            4,
                            http({
                                method: "post",
                                headers: {
                                    Authorization: "Bearer ".concat(accessToken)
                                },
                                url: endPoint.ALL_CATALOG,
                                data: printPayload
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        responseData = (_result_data = result.data) === null || _result_data === void 0 ? void 0 : _result_data.data;
                        rows = Array.isArray(responseData) ? responseData : (responseData === null || responseData === void 0 ? void 0 : responseData.data) || [];
                        normalizedRows = normalizeCatalogPdfRows(rows);
                        printRowsCacheRef.current.set(printCacheKey, normalizedRows);
                        return [
                            2,
                            normalizedRows
                        ];
                }
            });
        });
        return function fetchCatalogRowsForPrint() {
            return _ref.apply(this, arguments);
        };
    }();
    var openCatalogPdfBlob = function(blob, even) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var url = URL.createObjectURL(blob);
        var fileName = getCatalogPdfFileName(even, options);
        var newWindow = window.open(url, "_blank");
        if (newWindow) {
            newWindow.document.write("\n      <html>\n        <head>\n          <title>".concat(fileName, '</title>\n        </head>\n        <body style="margin:0;">\n          <iframe src="').concat(url, '" width="100%" height="100%" style="border:none;"></iframe>\n        </body>\n      </html>\n      '));
            setTimeout(function() {
                URL.revokeObjectURL(url);
            }, 60000);
        } else {
            URL.revokeObjectURL(url);
            alert("\xe0\xb9„\xe0\xb8\xa1\xe0\xb9ˆ\xe0\xb8\xaa\xe0\xb8\xb2\xe0\xb8\xa1\xe0\xb8\xb2\xe0\xb8\xa3\xe0\xb8–\xe0\xb9€\xe0\xb8›\xe0\xb8\xb4\xe0\xb8”\xe0\xb8\xab\xe0\xb8™\xe0\xb9‰\xe0\xb8\xb2\xe0\xb8•\xe0\xb9ˆ\xe0\xb8\xb2\xe0\xb8‡\xe0\xb9ƒ\xe0\xb8\xab\xe0\xb8\xa1\xe0\xb9ˆ\xe0\xb9„\xe0\xb8”\xe0\xb9‰ \xe0\xb8\x81\xe0\xb8\xa3\xe0\xb8\xb8\xe0\xb8“\xe0\xb8\xb2\xe0\xb8\xad\xe0\xb8™\xe0\xb8\xb8\xe0\xb8\x8d\xe0\xb8\xb2\xe0\xb8• pop-up");
        }
    };
    var downloadCatalogPdfBlob = function(blob, even) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var url = URL.createObjectURL(blob);
        var link = document.createElement("a");
        link.href = url;
        link.download = getCatalogPdfFileName(even, options);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 1000);
    };
    var handlePrintDocument = function() {
        var _ref = _async_to_generator(function(even) {
            var options, printRows, _tmp, blob;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                        if (isPrintingPdf) {
                            return [
                                2
                            ];
                        }
                        setIsPrintingPdf(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            6,
                            7
                        ]);
                        if (!(options.fetchAll === false)) return [
                            3,
                            2
                        ];
                        _tmp = options.rowData || rowData;
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            fetchCatalogRowsForPrint(options)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        printRows = _tmp;
                        return [
                            4,
                            createCatalogPdfBlob(even, _object_spread_props(_object_spread({}, options), {
                                rowData: printRows,
                                normalizedRowData: options.fetchAll !== false
                            }))
                        ];
                    case 5:
                        blob = _state.sent();
                        openCatalogPdfBlob(blob, even, options);
                        downloadCatalogPdfBlob(blob, even, options);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        setIsPrintingPdf(false);
                        return [
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePrintDocument(even) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePrintCatalogLevel = function() {
        var _ref = _async_to_generator(function(printType, priceLevel) {
            var isPromotion, isThai, collectionTitle;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isPromotion = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        isThai = printType === "th";
                        collectionTitle = isPromotion ? isThai ? "สินค้าโปรโมชั่น" : "ສິນຄ້າໂປຣໂມຊັ່ນ" : isThai ? "แคตตาล็อกสินค้า" : "ລາຍການສິນຄ້າ";
                        return [
                            4,
                            handlePrintDocument(printType, _object_spread({
                                priceLevel: priceLevel,
                                isPromotion: isPromotion,
                                headerTitle: "".concat(collectionTitle, " \xb7 Level ").concat(priceLevel)
                            }, isPromotion && {
                                payload: {
                                    bookid: parseInt(dataID),
                                    promotion: 1
                                }
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePrintCatalogLevel(printType, priceLevel) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderCatalogPrintLevels = function(printType) {
        var isPromotion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return /*#__PURE__*/ _jsx("div", {
            className: "catalog-print-level-grid",
            children: [
                1,
                2,
                3,
                4
            ].map(function(priceLevel) {
                return /*#__PURE__*/ _jsxs(Dropdown.Item, {
                    disabled: isPrintingPdf || isPromotion && Number(mainCounts.promotion || 0) === 0,
                    title: "พิมพ์ Level ".concat(priceLevel),
                    onClick: function() {
                        return handlePrintCatalogLevel(printType, priceLevel, isPromotion);
                    },
                    children: [
                        "Level ",
                        priceLevel
                    ]
                }, "".concat(isPromotion ? "promotion" : "catalog", "-").concat(printType, "-").concat(priceLevel));
            })
        });
    };
    // ดึงข้อมูลจาก summary
    var mainCounts = useMemo(function() {
        if (summary && summary.length > 0) {
            var _firstItem_totalProducts, _firstItem_totalRecommend, _firstItem_totalNew, _firstItem_totalPromotion, _firstItem_totalDelete;
            var firstItem = summary[0];
            // รวมจำนวนสินค้าทั้งหมดใน brand
            var totalBrand = 0;
            summary.forEach(function(item) {
                if (item.brand) {
                    item.brand.forEach(function(b) {
                        totalBrand += b.totalProducts || 0;
                    });
                }
            });
            // รวมจำนวนสินค้าทั้งหมดใน producttype
            var totalProductType = 0;
            summary.forEach(function(item) {
                if (item.producttype) {
                    item.producttype.forEach(function(p) {
                        totalProductType += p.totalProducts || 0;
                    });
                }
            });
            // รวมจำนวนสินค้าทั้งหมดใน category
            var totalCategory = 0;
            summary.forEach(function(item) {
                if (item.category) {
                    item.category.forEach(function(c) {
                        totalCategory += c.totalProducts || 0;
                    });
                }
            });
            // รวมจำนวนสินค้าทั้งหมดใน categorysub
            var totalCategorySub = 0;
            summary.forEach(function(item) {
                if (item.categorysub) {
                    item.categorysub.forEach(function(cs) {
                        totalCategorySub += cs.totalProducts || 0;
                    });
                }
            });
            return {
                total: ((_firstItem_totalProducts = firstItem.totalProducts) === null || _firstItem_totalProducts === void 0 ? void 0 : _firstItem_totalProducts.cl_catalog_id) || 0,
                recommend: ((_firstItem_totalRecommend = firstItem.totalRecommend) === null || _firstItem_totalRecommend === void 0 ? void 0 : _firstItem_totalRecommend.cl_catalog_id) || 0,
                new: ((_firstItem_totalNew = firstItem.totalNew) === null || _firstItem_totalNew === void 0 ? void 0 : _firstItem_totalNew.cl_catalog_id) || 0,
                promotion: ((_firstItem_totalPromotion = firstItem.totalPromotion) === null || _firstItem_totalPromotion === void 0 ? void 0 : _firstItem_totalPromotion.cl_catalog_id) || 0,
                deleted: ((_firstItem_totalDelete = firstItem.totalDelete) === null || _firstItem_totalDelete === void 0 ? void 0 : _firstItem_totalDelete.cl_catalog_id) || 0,
                brand: totalBrand,
                productType: totalProductType,
                category: totalCategory,
                categorySub: totalCategorySub
            };
        }
        return {
            total: 0,
            recommend: 0,
            new: 0,
            promotion: 0,
            deleted: 0,
            brand: 0,
            productType: 0,
            category: 0,
            categorySub: 0
        };
    }, [
        summary
    ]);
    // numberMappingDataSummary
    useEffect(function() {
        try {
            // Brand
            var mappingBrand = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_brand;
                (_item_brand = item.brand) === null || _item_brand === void 0 ? void 0 : _item_brand.forEach(function(b) {
                    mappingBrand[b.id] = b.totalProducts;
                });
            });
            setBrandData(mappingBrand);
            // Producttype
            var mappingProducttype = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_producttype;
                (_item_producttype = item.producttype) === null || _item_producttype === void 0 ? void 0 : _item_producttype.forEach(function(b) {
                    mappingProducttype[b.id] = b.totalProducts;
                });
            });
            setProducttypeData(mappingProducttype);
            var mappingCatalog = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_category;
                (_item_category = item.category) === null || _item_category === void 0 ? void 0 : _item_category.forEach(function(b) {
                    mappingCatalog[b.id] = b.totalProducts;
                });
            });
            setCategoryData(mappingCatalog);
            var mappingSubCatalog = {};
            summary === null || summary === void 0 ? void 0 : summary.forEach(function(item) {
                var _item_categorysub;
                (_item_categorysub = item.categorysub) === null || _item_categorysub === void 0 ? void 0 : _item_categorysub.forEach(function(b) {
                    mappingSubCatalog[b.id] = b.totalProducts;
                });
            });
            setCategorysubData(mappingSubCatalog);
        } catch (error) {
            console.error("Error fetching brand data:", error);
        }
    }, [
        summary
    ]);
    // แสดงผล Tab Brand
    var renderBrandTabs = function() {
        return brandType.map(function(brand) {
            var totalProducts = brandData[brand.set_brand_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: brand.set_brand_id,
                    children: [
                        brand.set_brand_name,
                        " (",
                        totalProducts,
                        ")"
                    ]
                })
            }, brand.set_brand_id);
        });
    };
    // แสดงผล Tab Producttype
    var renderProducttypeTabs = function() {
        return productType.map(function(pd) {
            var totalProducts = producttypeData[pd.set_producttype_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: pd.set_producttype_id,
                    children: [
                        pd.set_producttype_name,
                        " (",
                        totalProducts,
                        ")"
                    ]
                })
            }, pd.set_producttype_id);
        });
    };
    // แสดงผล Tab Category
    var renderCategoryTabs = function() {
        return typeCategory.map(function(pd) {
            var totalProducts = categoryData[pd.set_productcategory_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: pd.set_productcategory_id,
                    children: [
                        pd.set_productcategory_name,
                        " (",
                        totalProducts,
                        ")"
                    ]
                })
            }, pd.set_productcategory_id);
        });
    };
    // แสดงผล Tab SubCategory
    var renderSubCategoryTabs = function() {
        return typeSubCategory.map(function(pd) {
            var totalProducts = categorysubData[pd.set_productcategorysub_id] || 0;
            return /*#__PURE__*/ _jsx(Nav.Item, {
                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                    className: "tc-13 nav-danger",
                    eventKey: pd.set_productcategorysub_id,
                    children: [
                        pd.set_productcategorysub_name,
                        " (",
                        totalProducts,
                        ")"
                    ]
                })
            }, pd.set_productcategorysub_id);
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการเล่มแคตตาล็อก"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook/catalog/".concat(dataID),
                                        className: "tc-7  text-decoration-none fw-bold",
                                        children: "จัดการแคตตาล็อกสินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "fs-24 mb-2",
                        children: [
                            "จัดการแคตตาล็อกสินค้า",
                            catalogBookHeaderText && /*#__PURE__*/ _jsx("span", {
                                className: "ms-2 fw-bold",
                                children: catalogBookHeaderText
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        activeKey: String(tabStatus),
                        onSelect: handleTabStatusSelect,
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: [
                                        "ทั้งหมด (",
                                        mainCounts.total,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    children: [
                                        "สินค้าขายดี (",
                                        mainCounts.recommend,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    children: [
                                        "สินค้ามาใหม่ (",
                                        mainCounts.new,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    children: [
                                        "โปรโมชัน (",
                                        mainCounts.promotion,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "4",
                                    children: [
                                        "แบรนด์ (",
                                        mainCounts.brand,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "5",
                                    children: [
                                        "ประเภทสินค้า (",
                                        mainCounts.productType,
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "6",
                                    children: [
                                        "รายการที่ถูกลบ (",
                                        mainCounts.deleted,
                                        ")"
                                    ]
                                })
                            })
                        ]
                    }),
                    tabStatus == 4 && /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        activeKey: String(tabBrandType),
                        onSelect: handleBrandTabSelect,
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: [
                                        "ทั้งหมด (",
                                        mainCounts.brand,
                                        ")"
                                    ]
                                })
                            }),
                            renderBrandTabs()
                        ]
                    }),
                    tabStatus == 5 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "tc-10 fs-12 mb-2",
                                children: "ประเภทสินค้า"
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabPdType),
                                onSelect: handleProductTypeTabSelect,
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                "ทั้งหมด (",
                                                mainCounts.productType,
                                                ")"
                                            ]
                                        })
                                    }),
                                    renderProducttypeTabs()
                                ]
                            })
                        ]
                    }),
                    tabStatus == 5 && tabPdType != 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            tabPdType != 0 && /*#__PURE__*/ _jsx("div", {
                                className: "tc-10 fs-12 mb-2",
                                children: "หมวดหมู่"
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabCateType),
                                onSelect: handleCategoryTabSelect,
                                className: "mb-3",
                                children: [
                                    tabPdType != 0 && /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                "ทั้งหมด (",
                                                mainCounts.category,
                                                ")"
                                            ]
                                        })
                                    }),
                                    renderCategoryTabs()
                                ]
                            })
                        ]
                    }),
                    tabStatus == 5 && tabCateType != 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            tabCateType != 0 && /*#__PURE__*/ _jsx("div", {
                                className: "tc-10 fs-12 mb-2",
                                children: "หมวดหมู่ย่อย"
                            }),
                            /*#__PURE__*/ _jsxs(Nav, {
                                variant: "pills",
                                activeKey: String(tabSubCateType),
                                onSelect: handleSubCategoryTabSelect,
                                className: "mb-3",
                                children: [
                                    tabCateType != 0 && /*#__PURE__*/ _jsx(Nav.Item, {
                                        children: /*#__PURE__*/ _jsxs(Nav.Link, {
                                            className: "tc-13 nav-danger",
                                            eventKey: "0",
                                            children: [
                                                "ทั้งหมด (",
                                                mainCounts.categorySub,
                                                ")"
                                            ]
                                        })
                                    }),
                                    renderSubCategoryTabs()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsx(CardBody, {
                                children: /*#__PURE__*/ _jsxs(Row, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 7,
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "text",
                                                        className: "form-control form-st-4 form-200 mb-2",
                                                        placeholder: "ค้นหารายการสินค้า / รหัสสินค้า / บาร์โค้ด",
                                                        value: filterText,
                                                        onChange: function(e) {
                                                            setFilterText(e.target.value);
                                                        // handleSearchList(statusContract, e.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        className: "btn-st-7 bt-width-120 px-2 py-2 ml-2 mb-2",
                                                        onClick: function() {
                                                            loadSearchPin();
                                                        },
                                                        variant: "",
                                                        children: "ค้นหา"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Col, {
                                            xs: 12,
                                            md: 8,
                                            lg: 5,
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                justifyContent: "flex-end",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        style: {
                                                            display: "none"
                                                        },
                                                        children: /*#__PURE__*/ _jsx(PRPrint, {
                                                            innerRef: componentRef,
                                                            rowData: rowData
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(DropdownButton, {
                                                        id: "dropdown-print",
                                                        disabled: isPrintingPdf,
                                                        title: /*#__PURE__*/ _jsxs("span", {
                                                            className: "text-white pr-2",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("i", {
                                                                    className: "iprinter"
                                                                }),
                                                                " พิมพ์เอกสาร"
                                                            ]
                                                        }),
                                                        className: "me-3 ".concat(isPrintingPdf ? "catalog-print-loading" : ""),
                                                        style: {
                                                            border: "1px solid #B00412 !important",
                                                            background: "#B00412",
                                                            color: "#FFF !important",
                                                            borderRadius: "8px"
                                                        },
                                                        variant: "",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Dropdown.Header, {
                                                                children: "แคตตาล็อกปกติ \xb7 ภาษาไทย"
                                                            }),
                                                            renderCatalogPrintLevels("th"),
                                                            /*#__PURE__*/ _jsx(Dropdown.Header, {
                                                                children: "แคตตาล็อกปกติ \xb7 ພາສາລາວ"
                                                            }),
                                                            renderCatalogPrintLevels("la"),
                                                            /*#__PURE__*/ _jsx(Dropdown.Divider, {}),
                                                            /*#__PURE__*/ _jsx(Dropdown.Header, {
                                                                children: "เฉพาะสินค้าโปรโมชั่น \xb7 ภาษาไทย"
                                                            }),
                                                            renderCatalogPrintLevels("th", true),
                                                            /*#__PURE__*/ _jsx(Dropdown.Header, {
                                                                children: "ໂປຣໂມຊັ່ນ \xb7 ພາສາລາວ"
                                                            }),
                                                            renderCatalogPrintLevels("la", true)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Link, {
                                                        className: "btn btn-dg w-[200px]",
                                                        to: "/clbook/catalog/".concat(dataID, "/manage"),
                                                        children: "สร้างแคตตาล็อกสินค้า"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "table-scroll-x",
                                children: /*#__PURE__*/ _jsxs("table", {
                                    className: "product-table",
                                    children: [
                                        /*#__PURE__*/ _jsx("thead", {
                                            style: {
                                                backgroundColor: "#cc0000",
                                                color: "white"
                                            },
                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ลำดับ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        style: {
                                                            width: "150px"
                                                        },
                                                        children: "รูปสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        style: {
                                                            width: "550px"
                                                        },
                                                        children: "ชื่อสินค้า"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "Barcode"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ขนาดบรรจุ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "ราคาแนะนำขาย"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("th", {
                                                        className: "catalog-wholesale-tier-header",
                                                        children: [
                                                            "ราคาส่ง 4 ระดับ",
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "catalog-wholesale-tier-subtitle fw-normal",
                                                                children: "ราคาตั้งต้น \xb7 Ex VAT / In VAT"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "โปรโมชัน"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "สินค้าขายดี"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "สินค้ามาใหม่"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "สถานะ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "Continue"
                                                    }),
                                                    /*#__PURE__*/ _jsx("th", {
                                                        children: "จัดการ"
                                                    })
                                                ]
                                            })
                                        }),
                                        rowData.length > 0 && /*#__PURE__*/ _jsx("tbody", {
                                            children: rowData.map(function(row, i) {
                                                return /*#__PURE__*/ _jsxs("tr", {
                                                    style: {
                                                        borderBottom: "1px solid #d2d2d2"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: row.cl_catalog_orderby
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx("center", {
                                                                style: {
                                                                    width: "150px"
                                                                },
                                                                children: row.cl_catalog_image ? /*#__PURE__*/ _jsx("img", {
                                                                    src: row.cl_catalog_image,
                                                                    alt: "สินค้า",
                                                                    loading: "lazy",
                                                                    decoding: "async"
                                                                }) : ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("td", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-[10px] text-left",
                                                                    children: row.cl_catalog_name
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-[10px] tc-7 fs-12 text-left",
                                                                    children: row.cl_catalog_nameen || "-"
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-[10px] tc-7 fs-12 text-left",
                                                                    children: row.cl_catalog_namela || "-"
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "mb-[10px] tc-7 fs-12 text-left",
                                                                    children: row.pd_product_code || "-"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: row.ClDetail.map(function(ele, index) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-center mb-[8px] ".concat(ele.cl_detail_showbarcode == 2 && "!text-[#b00512] semibold-text"),
                                                                    children: ele.cl_detail_barcode
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: row.ClDetail.map(function(ele, index) {
                                                                var _ele_SetUnit;
                                                                return /*#__PURE__*/ _jsxs("div", {
                                                                    className: "text-left mb-[8px]",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            style: {
                                                                                float: "left",
                                                                                width: "40px"
                                                                            },
                                                                            children: ((_ele_SetUnit = ele.SetUnit) === null || _ele_SetUnit === void 0 ? void 0 : _ele_SetUnit.set_unit_name) ? " ".concat(ele.SetUnit.set_unit_name) : ""
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: "="
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "!bg-[#d9d9ded9] pl-2 pr-3 pt-2 pb-2 ml-2",
                                                                            style: {
                                                                                borderRadius: 5
                                                                            },
                                                                            children: ele.cl_detail_ratio ? " ".concat(ele.cl_detail_ratio) : ""
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: ele.cl_detail_ratio ? " ชิ้น" : ""
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: ele.cl_detail_ratiooption ? " / ".concat(ele.cl_detail_ratiooption, " แพ็ค") : ""
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: row.ClDetail.map(function(ele, index) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-right mb-[8px]",
                                                                    children: NumberFormat(ele.cl_detail_price, 2)
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "catalog-wholesale-tier-cell",
                                                            children: row.ClDetail.map(function(detail, index) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "catalog-wholesale-tier-row",
                                                                    children: /*#__PURE__*/ _jsx(CatalogWholesaleTierPrices, {
                                                                        detail: detail
                                                                    })
                                                                }, index);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: row.SetPromotion ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "mb-[10px] text-center",
                                                                        children: row.SetPromotion.set_promotion_name
                                                                    }),
                                                                    row.SetPromotion.set_promotion_type == 3 && /*#__PURE__*/ _jsx("div", {
                                                                        className: "mb-[10px] text-center",
                                                                        children: row.SetPromotion.set_promotion_buy && row.SetPromotion.set_promotion_free && /*#__PURE__*/ _jsxs(Stack, {
                                                                            direction: "row",
                                                                            justifyContent: "space-between",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "pt-2 ml-10",
                                                                                    children: /*#__PURE__*/ _jsxs("span", {
                                                                                        className: "!bg-[#0012fd] text-white px-2 py-1 fs-12",
                                                                                        style: {
                                                                                            borderRadius: 10
                                                                                        },
                                                                                        children: [
                                                                                            row.SetPromotion.set_promotion_buy ? "".concat(row.SetPromotion.set_promotion_buy, " +") : "",
                                                                                            row.SetPromotion.set_promotion_free ? "".concat(row.SetPromotion.set_promotion_free) : ""
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fs-14",
                                                                                    style: {
                                                                                        color: "#0012fd"
                                                                                    },
                                                                                    children: row.ClDetail.map(function(ele, index) {
                                                                                        return /*#__PURE__*/ _jsx(_Fragment, {
                                                                                            children: ele.cl_detail_wholesaleavg ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("p", {
                                                                                                        children: "เฉลี่ยแพ็คละ"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("p", {
                                                                                                        children: ele.cl_detail_wholesaleavg
                                                                                                    })
                                                                                                ]
                                                                                            }) : ""
                                                                                        });
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "mb-[10px] text-center",
                                                                        children: [
                                                                            moment(row.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                                            " ",
                                                                            "-",
                                                                            " ",
                                                                            moment(row.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                                        ]
                                                                    })
                                                                ]
                                                            }) : "-"
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                    title: "สถานะสินค้าขายดี",
                                                                    children: /*#__PURE__*/ _jsx(Switch, {
                                                                        checked: row.cl_catalog_recom == 1,
                                                                        onClick: function() {
                                                                            setModalStatus(function(prev) {
                                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                                    open: true,
                                                                                    typeData: "recom",
                                                                                    data: {
                                                                                        id: row.cl_catalog_id,
                                                                                        name: row.cl_catalog_name,
                                                                                        status: row.cl_catalog_recom
                                                                                    }
                                                                                });
                                                                            });
                                                                            setmodelText("สถานะสินค้าขายดี");
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                    title: "สถานะสินค้ามาใหม่",
                                                                    children: /*#__PURE__*/ _jsx(Switch, {
                                                                        checked: row.cl_catalog_new == 1,
                                                                        onClick: function() {
                                                                            setModalStatus(function(prev) {
                                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                                    open: true,
                                                                                    typeData: "new",
                                                                                    data: {
                                                                                        id: row.cl_catalog_id,
                                                                                        name: row.cl_catalog_name,
                                                                                        status: row.cl_catalog_new
                                                                                    }
                                                                                });
                                                                            });
                                                                            setmodelText("สถานะสินค้ามาใหม่");
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                    title: "สถานะแคตตาล็อกสินค้า",
                                                                    children: /*#__PURE__*/ _jsx(Switch, {
                                                                        checked: row.cl_catalog_status == 1,
                                                                        onClick: function() {
                                                                            setModalStatus(function(prev) {
                                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                                    open: true,
                                                                                    typeData: "status",
                                                                                    data: {
                                                                                        id: row.cl_catalog_id,
                                                                                        name: row.cl_catalog_name,
                                                                                        status: row.cl_catalog_status
                                                                                    }
                                                                                });
                                                                            });
                                                                            setmodelText("สถานะแคตตาล็อกสินค้า");
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "text-center",
                                                            children: /*#__PURE__*/ _jsx(Switch, {
                                                                checked: Number(row.pd_product_continue) === 1,
                                                                disabled: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                children: [
                                                                    row.cl_catalog_deleted == 2 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Link, {
                                                                                to: "/clbook/catalog/".concat(dataID, "/action/").concat(row.cl_catalog_id),
                                                                                state: {
                                                                                    catalogListState: currentCatalogListState
                                                                                },
                                                                                style: {
                                                                                    marginRight: 5
                                                                                },
                                                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                                    title: "แก้ไขรายการ",
                                                                                    children: /*#__PURE__*/ _jsx(EditIcon, {
                                                                                        style: {
                                                                                            color: "#797A7A",
                                                                                            fontSize: 30,
                                                                                            borderRadius: 40,
                                                                                            background: "#E9E9E9",
                                                                                            padding: 5
                                                                                        }
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Link, {
                                                                                onClick: function() {
                                                                                    setModalDel(function(prev) {
                                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                                            open: true,
                                                                                            data: {
                                                                                                id: row.cl_catalog_id,
                                                                                                name: row.cl_catalog_name
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                    setmodelText("ยืนยันลบแคตตาล็อกสินค้า");
                                                                                },
                                                                                style: {
                                                                                    marginRight: 3
                                                                                },
                                                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                                    title: "ลบรายการ",
                                                                                    children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                                                                        style: {
                                                                                            fontSize: 30,
                                                                                            borderRadius: 40,
                                                                                            background: "rgb(255, 227, 227)",
                                                                                            color: "#FF0000",
                                                                                            padding: 5
                                                                                        }
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Link, {
                                                                                onClick: function() {
                                                                                    setModalUpdateDetail(function(prev) {
                                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                                            open: true,
                                                                                            data: {
                                                                                                id: row.cl_catalog_id,
                                                                                                name: row.cl_catalog_name
                                                                                            }
                                                                                        });
                                                                                    });
                                                                                    setmodelText("ยืนยันอัพเดทข้อมูลแคตตาล็อกสินค้า");
                                                                                },
                                                                                style: {
                                                                                    marginRight: 3
                                                                                },
                                                                                children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                                    title: "อัพเดทข้อมูลรายการ",
                                                                                    children: /*#__PURE__*/ _jsx(SystemUpdateAltIcon, {
                                                                                        style: {
                                                                                            fontSize: 30,
                                                                                            borderRadius: 40,
                                                                                            background: "#0284fe1a",
                                                                                            color: "#0284feff",
                                                                                            padding: 5
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    row.cl_catalog_deleted == 1 && /*#__PURE__*/ _jsx(Link, {
                                                                        onClick: function() {
                                                                            setModalDelOpen(function(prev) {
                                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                                    open: true,
                                                                                    data: {
                                                                                        id: row.cl_catalog_id,
                                                                                        name: row.cl_catalog_name
                                                                                    }
                                                                                });
                                                                            });
                                                                            setmodelText("ยืนยันคืนค่าการลบแคตตาล็อกสินค้า");
                                                                        },
                                                                        style: {
                                                                            marginRight: 3
                                                                        },
                                                                        children: /*#__PURE__*/ _jsx(Tooltip, {
                                                                            title: "คืนค่าการลบรายการ",
                                                                            children: /*#__PURE__*/ _jsx(ReplayIcon, {
                                                                                style: {
                                                                                    fontSize: 30,
                                                                                    borderRadius: 40,
                                                                                    background: "#eaf9f0",
                                                                                    color: "#2DC76D",
                                                                                    padding: 5
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        }),
                                        rowData.length == 0 && /*#__PURE__*/ _jsx("tbody", {
                                            children: /*#__PURE__*/ _jsx("tr", {
                                                children: /*#__PURE__*/ _jsx("td", {
                                                    colSpan: 15,
                                                    className: "!bg-[#FFF]",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "py-5 my-5",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                class: "table-no-result mx-auto mb-4"
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                class: "text-center fs-24 tc-13",
                                                                children: "ไม่มีรายการ"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    padding: "15px 10px",
                                    gap: "15px",
                                    fontSize: "14px",
                                    color: "#333",
                                    borderTop: "1px solid #e0e0e0"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    fontSize: "14px",
                                                    color: "#666"
                                                },
                                                children: "จำนวนรายการต่อหน้า"
                                            }),
                                            /*#__PURE__*/ _jsx("select", {
                                                value: pageSize,
                                                onChange: function(e) {
                                                    setPageSize(Number(e.target.value));
                                                    setPageId(1);
                                                },
                                                style: {
                                                    padding: "4px 8px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "4px",
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                    outline: "none"
                                                },
                                                children: [
                                                    5,
                                                    10,
                                                    25,
                                                    50,
                                                    100
                                                ].map(function(size) {
                                                    return /*#__PURE__*/ _jsx("option", {
                                                        value: size,
                                                        children: size
                                                    }, size);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx("span", {
                                            children: totalAmount > 0 ? "".concat((pageId - 1) * pageSize + 1, "-").concat(Math.min(pageId * pageSize, totalAmount), " of ").concat(totalAmount) : "0-0 of 0"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        style: {
                                            display: "flex",
                                            gap: "5px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return setPageId(1);
                                                },
                                                disabled: pageId <= 1,
                                                style: {
                                                    padding: "6px 10px",
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                    cursor: pageId <= 1 ? "not-allowed" : "pointer",
                                                    color: pageId <= 1 ? "#ccc" : "#666",
                                                    fontSize: "18px"
                                                },
                                                title: "หน้าแรก",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "\xab"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return setPageId(function(prev) {
                                                        return Math.max(prev - 1, 1);
                                                    });
                                                },
                                                disabled: pageId <= 1,
                                                style: {
                                                    padding: "6px 10px",
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                    cursor: pageId <= 1 ? "not-allowed" : "pointer",
                                                    color: pageId <= 1 ? "#ccc" : "#666",
                                                    fontSize: "18px"
                                                },
                                                title: "หน้าก่อน",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "‹"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return setPageId(function(prev) {
                                                        return Math.min(prev + 1, totalPage || 1);
                                                    });
                                                },
                                                disabled: pageId >= totalPage,
                                                style: {
                                                    padding: "6px 10px",
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                    cursor: pageId >= totalPage ? "not-allowed" : "pointer",
                                                    color: pageId >= totalPage ? "#ccc" : "#333",
                                                    fontSize: "18px"
                                                },
                                                title: "หน้าถัดไป",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "›"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                onClick: function() {
                                                    return setPageId(totalPage || 1);
                                                },
                                                disabled: pageId >= totalPage,
                                                style: {
                                                    padding: "6px 10px",
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                    cursor: pageId >= totalPage ? "not-allowed" : "pointer",
                                                    color: pageId >= totalPage ? "#ccc" : "#666",
                                                    fontSize: "18px"
                                                },
                                                title: "หน้าสุดท้าย",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "\xbb"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalStatus,
                setModal: setModalStatus,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(StatusModal, {
                    setModal: setModalStatus,
                    modal: modalStatus,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modelText: modelText,
                    modalObj: modalObj,
                    setTabStatus: setTabStatus,
                    setDataForSearch: setDataForSearch,
                    dataForSearch: dataForSearch,
                    dataID: dataID
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    setDataForSearch: setDataForSearch,
                    dataForSearch: dataForSearch,
                    dataID: dataID
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDelOpen,
                setModal: setModalDelOpen,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelOpenModel, {
                    setModal: setModalDelOpen,
                    modal: modalDelOpen,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    setDataForSearch: setDataForSearch,
                    dataForSearch: dataForSearch,
                    dataID: dataID
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalUpdateDetail,
                setModal: setModalUpdateDetail,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(UpdateDetailModel, {
                    setModal: setModalUpdateDetail,
                    modal: modalUpdateDetail,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    setDataForSearch: setDataForSearch,
                    dataForSearch: dataForSearch,
                    dataID: dataID
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function CatalogManage() {
    var _productRow_find, _productRow_find1, _productRow_find2;
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), filteredItems = _useState[0], setFilteredItems = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), productRow = _useState1[0], setProductRow = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), modalsuccess = _useState2[0], setModalsuccess = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), textsuccess = _useState3[0], setTextsuccess = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), row = _useState4[0], setRow = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionBrand = _useState5[0], setOptionBrand = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), brandId = _useState6[0], setBrandId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(null), 2), pricingProductId = _useState7[0], setPricingProductId = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState8[0], setModal = _useState8[1];
    var getProductReducer = useAppSelector(function(state) {
        return state.getProductReducer;
    });
    var createCatalogReducer = useAppSelector(function(state) {
        return state.createCatalogReducer;
    });
    var getAllMstBrandReducer = useAppSelector(function(state) {
        return state.getAllMstBrandReducer;
    });
    useEffect(function() {
        setIsLoading(createCatalogReducer.isFetching);
        if (createCatalogReducer.data && !createCatalogReducer.isError) {
            setTextsuccess("สร้างแคตตาล็อกสินค้า");
            setModalsuccess(true);
            dispatch(clearcreateCatalog());
        // navigate(`/clbook/catalog/${dataID}`);
        }
    }, [
        createCatalogReducer
    ]);
    useEffect(function() {
        dispatch(getAllMstBrand());
    }, []);
    useEffect(function() {
        var data = {
            cl_book_id: parseInt(dataID),
            brand_id: parseInt(brandId)
        };
        dispatch(getProduct(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        dataID,
        brandId
    ]);
    useEffect(function() {
        setIsLoading(getProductReducer.isFetching || getAllMstBrandReducer.isFetching);
        if (getProductReducer.data) {
            var newRow = getProductReducer.data.data.map(function(item) {
                var _item_SetBrand;
                return {
                    id: item.pd_product_id,
                    code: item.pd_product_code,
                    barcode: item.pd_product_barcode,
                    name: item.pd_product_nameth,
                    option: "option",
                    unit: item.SetUnit ? item.SetUnit.set_unit_name : "-",
                    rate: item.pd_product_unitweightid,
                    pricePresent: item.pd_product_price,
                    priceRecommended: item.pd_product_recommentprice,
                    gp: item.pd_product_gp,
                    status: item.pd_product_status,
                    product_id: item.pd_product_id,
                    brandName: item === null || item === void 0 ? void 0 : (_item_SetBrand = item.SetBrand) === null || _item_SetBrand === void 0 ? void 0 : _item_SetBrand.set_brand_name,
                    detailPrices: (item.PdPdetail || []).map(function(detail) {
                        var _detail_SetUnit;
                        var defaultPrice = Number((Number(detail.pd_pdetail_recommentprice || 0) * 0.7).toFixed(2));
                        return {
                            pd_pdetail_id: detail.pd_pdetail_id,
                            barcode: detail.pd_pdetail_barcode,
                            unitName: ((_detail_SetUnit = detail.SetUnit) === null || _detail_SetUnit === void 0 ? void 0 : _detail_SetUnit.set_unit_name) || "-",
                            ratio: detail.pd_pdetail_ratio,
                            level1: defaultPrice,
                            level2: defaultPrice,
                            level3: defaultPrice,
                            level4: defaultPrice
                        };
                    })
                };
            });
            setRow(newRow);
            setFilteredItems(newRow);
        }
        if (getAllMstBrandReducer.data) {
            var arr = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            getAllMstBrandReducer.data.data.map(function(ele) {
                return arr.push({
                    value: ele === null || ele === void 0 ? void 0 : ele.set_brand_id,
                    label: ele === null || ele === void 0 ? void 0 : ele.set_brand_name
                });
            });
            setOptionBrand(arr);
        }
    }, [
        getProductReducer,
        getAllMstBrandReducer
    ]);
    var columns = [
        {
            name: "รหัสสินค้า",
            selector: function(row) {
                return row.code;
            },
            center: "true",
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/product/productnormal/edit/" + row.product_id + "/view",
                        children: row.code ? row.code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "บาร์โค๊ด",
            selector: function(row) {
                return row.barcode;
            },
            center: "true",
            width: "150px"
        },
        {
            name: "ชื่อสินค้า",
            // center: "true",
            // width: "350px",
            selector: function(row) {
                return row.name;
            }
        },
        {
            name: "หน่วย",
            // center: "true",
            width: "80px",
            selector: function(row) {
                return row.unit;
            }
        },
        {
            name: "ราคาส่ง",
            center: "true",
            width: "100px",
            selector: function(row) {
                return NumberFormat(row.pricePresent ? row.pricePresent : 0, 2);
            }
        },
        {
            name: "ราคาขาย",
            center: "true",
            width: "100px",
            selector: function(row) {
                return NumberFormat(row.priceRecommended ? row.priceRecommended : 0, 2);
            }
        },
        {
            name: "GP",
            center: "true",
            width: "100px",
            selector: function(row) {
                return row.gp;
            },
            cell: function(row, index, column, id) {
                return row.gp + " %";
            }
        },
        {
            name: "สถานะ",
            center: "true",
            width: "150px",
            selector: function(row) {
                return row.status;
            },
            cell: function(row, index, column, id) {
                return row.status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6D788D)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "แบบร่าง"
                }) || row.status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รอตรวจสอบ"
                }) || row.status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FFFFFF",
                        backgroundColor: "#10B02A",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติ"
                }) || row.status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "กรุณาแก้ไขข้อมูล"
                });
            }
        },
        {
            name: "ราคา 4 ระดับ",
            center: "true",
            width: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(Button, {
                    type: "button",
                    size: "sm",
                    variant: "outline-primary",
                    onClick: function() {
                        return setPricingProductId(row.id);
                    },
                    className: "text-nowrap",
                    children: "ตั้งราคา"
                });
            }
        },
        {
            name: "จัดการ",
            center: "true",
            width: "120px",
            selector: function(row) {
                return row.id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(DeleteIcon, {
                        style: {
                            color: "#FFFFFF",
                            fontSize: 30,
                            borderRadius: 40,
                            background: "#F95057",
                            padding: 5
                        },
                        onClick: function() {
                            return onDel(row.id);
                        }
                    })
                });
            }
        }
    ];
    var onDel = function(id) {
        var newRows = productRow.filter(function(item) {
            return item.id !== id;
        });
        setProductRow(newRows);
    };
    var onClickSave = function() {
        var arr = [];
        productRow.map(function(ele) {
            return arr.push({
                pd_product_id: ele.id,
                detailPrices: (ele.detailPrices || []).map(function(detail) {
                    return {
                        pd_pdetail_id: detail.pd_pdetail_id,
                        level1: detail.level1 === "" ? null : Number(detail.level1),
                        level2: detail.level2 === "" ? null : Number(detail.level2),
                        level3: detail.level3 === "" ? null : Number(detail.level3),
                        level4: detail.level4 === "" ? null : Number(detail.level4)
                    };
                })
            });
        });
        var data = {
            cl_book_id: parseInt(dataID),
            detailcreate: arr
        };
        dispatch(createCatalog(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการเล่มแคตตาล็อก"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook/catalog/".concat(dataID),
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการแคตตาล็อกสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none fw-bold",
                                        children: "สร้างแคตตาล็อกสินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "สร้างแคตตาล็อกสินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-3 mb-3",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-xl-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4 mb-3",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-8 col-md-6"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-4 col-md-6 d-flex justify-content-end",
                                    children: /*#__PURE__*/ _jsx(Stack, {
                                        direction: "horizontal",
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            className: "btn btn-dg ml-2 py-2",
                                            style: {
                                                width: 150
                                            },
                                            onClick: function() {
                                                return setModal(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: true
                                                    });
                                                });
                                            },
                                            children: "เลือกสินค้า"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: productRow,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card pagezoom card-st-3 mb-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-xl-3 d-flex ",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function(e) {
                                navigate("/clbook/catalog/" + dataID);
                            },
                            className: "btn-st-6 me-3 btn ms-auto",
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            onClick: function(e) {
                                return onClickSave();
                            },
                            className: "btn-st-3 me-3",
                            children: "บันทึก"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    row: row,
                    setRow: setRow,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    filteredItems: filteredItems,
                    setFilteredItems: setFilteredItems,
                    setModal: setModal,
                    optionBrand: optionBrand,
                    setOptionBrand: setOptionBrand,
                    brandId: brandId,
                    setBrandId: setBrandId,
                    modalObj: modalObj,
                    setModalObj: setModalObj
                })
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                show: pricingProductId !== null,
                onHide: function() {
                    return setPricingProductId(null);
                },
                size: "xl",
                centered: true,
                fullscreen: "sm-down",
                children: [
                    /*#__PURE__*/ _jsx(Modal.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ _jsxs(Modal.Title, {
                            className: "fs-20",
                            children: [
                                "ตั้งราคาส่ง 4 ระดับ — ",
                                ((_productRow_find = productRow.find(function(item) {
                                    return item.id === pricingProductId;
                                })) === null || _productRow_find === void 0 ? void 0 : _productRow_find.name) || "สินค้า"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Modal.Body, {
                        children: [
                            (((_productRow_find1 = productRow.find(function(item) {
                                return item.id === pricingProductId;
                            })) === null || _productRow_find1 === void 0 ? void 0 : _productRow_find1.detailPrices) || []).map(function(detail) {
                                return /*#__PURE__*/ _jsxs("div", {
                                    className: "border rounded p-3 mb-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "fw-semibold mb-2",
                                            children: [
                                                detail.unitName,
                                                " ",
                                                detail.ratio ? "(".concat(detail.ratio, ")") : "",
                                                detail.barcode ? /*#__PURE__*/ _jsx("span", {
                                                    className: "text-muted ms-2",
                                                    children: detail.barcode
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "row g-2",
                                            children: [
                                                1,
                                                2,
                                                3,
                                                4
                                            ].map(function(level) /*#__PURE__*/ {
                                                var _detail_;
                                                return _jsx("div", {
                                                    className: "col-6 col-md-3",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "form-st-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                className: "mb-1",
                                                                children: [
                                                                    "Level ",
                                                                    level,
                                                                    " (Ex VAT)"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "number",
                                                                min: "0",
                                                                step: "0.01",
                                                                inputMode: "decimal",
                                                                value: (_detail_ = detail["level".concat(level)]) !== null && _detail_ !== void 0 ? _detail_ : "",
                                                                onChange: function(event) {
                                                                    var value = event.target.value;
                                                                    setProductRow(function(prev) {
                                                                        return prev.map(function(product) {
                                                                            return product.id !== pricingProductId ? product : _object_spread_props(_object_spread({}, product), {
                                                                                detailPrices: product.detailPrices.map(function(item) {
                                                                                    return item.pd_pdetail_id !== detail.pd_pdetail_id ? item : _object_spread_props(_object_spread({}, item), _define_property({}, "level".concat(level), value));
                                                                                })
                                                                            });
                                                                        });
                                                                    });
                                                                }
                                                            })
                                                        ]
                                                    })
                                                }, level);
                                            })
                                        })
                                    ]
                                }, detail.pd_pdetail_id);
                            }),
                            !(((_productRow_find2 = productRow.find(function(item) {
                                return item.id === pricingProductId;
                            })) === null || _productRow_find2 === void 0 ? void 0 : _productRow_find2.detailPrices) || []).length && /*#__PURE__*/ _jsx("div", {
                                className: "text-muted",
                                children: "สินค้านี้ยังไม่มีหน่วยบรรจุ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Modal.Footer, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "secondary",
                            onClick: function() {
                                return setPricingProductId(null);
                            },
                            children: "ปิด"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: "/clbook/catalog/".concat(dataID)
            })
        ]
    });
}
export function CatalogAction() {
    var _location_state;
    var navigate = useNavigate();
    var location = useLocation();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var actionID = useMemo(function() {
        return param.actionID ? param.actionID : null;
    }, [
        param.actionID
    ]);
    var catalogListState = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.catalogListState;
    var catalogListNavigationOptions = catalogListState ? {
        state: {
            catalogListState: catalogListState
        }
    } : undefined;
    var _useState = _sliced_to_array(useState({}), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), productRow = _useState1[0], setProductRow = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), optionsUnit = _useState2[0], setoptionsUnit = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), pdSelling = _useState3[0], setPdSelling = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), pdnew = _useState4[0], setPdNew = _useState4[1];
    var _useState5 = _sliced_to_array(useState(1), 2), type = _useState5[0], setType = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), typePromo = _useState6[0], setTypePromo = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), modalsuccess = _useState7[0], setModalsuccess = _useState7[1];
    var _useState8 = _sliced_to_array(useState(false), 2), textsuccess = _useState8[0], setTextsuccess = _useState8[1];
    var getCatalogByIdReducer = useAppSelector(function(state) {
        return state.getCatalogByIdReducer;
    });
    var getPromotionReducer = useAppSelector(function(state) {
        return state.getPromotionReducer;
    });
    var getAllMstUnitReducer = useAppSelector(function(state) {
        return state.getAllMstUnitReducer;
    });
    var updateCatalogReducer = useAppSelector(function(state) {
        return state.updateCatalogReducer;
    });
    useEffect(function() {
        dispatch(getCatalogById(parseInt(actionID), {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getPromotion({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllMstUnit({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getCatalogByIdReducer.isFetching || getPromotionReducer.isFetching || getAllMstUnitReducer.isFetching || updateCatalogReducer.isFetching);
        if (getCatalogByIdReducer.data) {
            var detail = getCatalogByIdReducer.data.data;
            setFormdata(detail);
            var cate = [];
            detail.ClDetail.map(function(ele) {
                var _ele_cl_detail_wholesale_level2, _ref, _ele_cl_detail_wholesale_level3, _ref1, _ele_cl_detail_wholesale_level4, _ref2;
                return cate.push({
                    id: nanoid(),
                    cl_detail_id: ele.cl_detail_id,
                    cl_detail_barcode: ele.cl_detail_barcode,
                    cl_detail_wholesale: ele.cl_detail_wholesale ? ele.cl_detail_wholesale : 0,
                    cl_detail_wholesale_level2: (_ref = (_ele_cl_detail_wholesale_level2 = ele.cl_detail_wholesale_level2) !== null && _ele_cl_detail_wholesale_level2 !== void 0 ? _ele_cl_detail_wholesale_level2 : ele.cl_detail_wholesale) !== null && _ref !== void 0 ? _ref : 0,
                    cl_detail_wholesale_level3: (_ref1 = (_ele_cl_detail_wholesale_level3 = ele.cl_detail_wholesale_level3) !== null && _ele_cl_detail_wholesale_level3 !== void 0 ? _ele_cl_detail_wholesale_level3 : ele.cl_detail_wholesale) !== null && _ref1 !== void 0 ? _ref1 : 0,
                    cl_detail_wholesale_level4: (_ref2 = (_ele_cl_detail_wholesale_level4 = ele.cl_detail_wholesale_level4) !== null && _ele_cl_detail_wholesale_level4 !== void 0 ? _ele_cl_detail_wholesale_level4 : ele.cl_detail_wholesale) !== null && _ref2 !== void 0 ? _ref2 : 0,
                    cl_detail_wholesalevat: ele.cl_detail_wholesalevat ? ele.cl_detail_wholesalevat : 0,
                    cl_detail_price: ele.cl_detail_price ? ele.cl_detail_price : 0,
                    cl_detail_unitid: ele.cl_detail_unitid,
                    cl_detail_showbarcode: ele.cl_detail_showbarcode ? ele.cl_detail_showbarcode : 1
                });
            });
            setProductRow(cate);
            setPdNew(detail.cl_catalog_new == 1 ? true : false);
            setPdSelling(detail.cl_catalog_recom == 1 ? true : false);
            setType(detail.cl_catalog_status);
        }
        if (getPromotionReducer.data) {
            var pmo = [
                {
                    value: 0,
                    label: "ไม่ระบุ"
                }
            ];
            getPromotionReducer.data.data.map(function(ele) {
                return pmo.push({
                    value: ele.set_promotion_id,
                    label: ele.set_promotion_name
                });
            });
            setTypePromo(pmo);
        }
        if (getAllMstUnitReducer.data) {
            var pmo1 = [];
            getAllMstUnitReducer.data.data.map(function(ele) {
                return pmo1.push({
                    value: ele.set_unit_id,
                    label: ele.set_unit_name
                });
            });
            setoptionsUnit(pmo1);
        }
        if (updateCatalogReducer.data && !updateCatalogReducer.isError) {
            setTextsuccess("แก้ไขแคตตาล็อกสินค้า");
            setModalsuccess(true);
            dispatch(clearupdateCatalog());
        }
    }, [
        getCatalogByIdReducer,
        getPromotionReducer,
        getAllMstUnitReducer,
        updateCatalogReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการเล่มแคตตาล็อก"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook/catalog/".concat(dataID),
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการแคตตาล็อกสินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/clbook/catalog/".concat(dataID),
                                        className: "tc-7  text-decoration-none fw-bold",
                                        children: "แก้ไขแคตตาล็อกสินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "แก้ไขแคตตาล็อกสินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validateOnMount: true,
                onSubmit: function(values) {
                    console.log("values", values);
                    var arr = [];
                    productRow.map(function(ele) {
                        return arr.push({
                            cl_detail_id: ele.cl_detail_id,
                            cl_detail_unitid: ele.cl_detail_unitid,
                            cl_detail_price: parseFloat(ele.cl_detail_price),
                            cl_detail_wholesale: parseFloat(ele.cl_detail_wholesale),
                            cl_detail_wholesale_level2: parseFloat(ele.cl_detail_wholesale_level2),
                            cl_detail_wholesale_level3: parseFloat(ele.cl_detail_wholesale_level3),
                            cl_detail_wholesale_level4: parseFloat(ele.cl_detail_wholesale_level4),
                            cl_detail_wholesalevat: parseFloat(ele.cl_detail_wholesalevat),
                            cl_detail_showbarcode: parseInt(ele.cl_detail_showbarcode)
                        });
                    });
                    var data = {
                        cl_catalog_id: parseInt(actionID),
                        cl_catalog_promotionid: values.cl_catalog_promotionid,
                        cl_catalog_name: values.cl_catalog_name,
                        cl_catalog_nameen: values.cl_catalog_nameen,
                        cl_catalog_namela: values.cl_catalog_namela,
                        cl_catalog_new: pdnew == true ? 1 : 2,
                        cl_catalog_recom: pdSelling == true ? 1 : 2,
                        cl_catalog_orderby: values.cl_catalog_orderby ? parseFloat(values.cl_catalog_orderby) : 0,
                        cl_catalog_status: type,
                        detailupdate: arr
                    };
                    dispatch(updateCatalog(data, {
                        modalObj: modalObj,
                        setModalObj: setModalObj
                    }));
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            handleSubmit();
                        },
                        children: [
                            /*#__PURE__*/ _jsx("fieldset", {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card pagezoom card-st-3 mb-4",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body px-xl-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "pt-3 px-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row gx-xl-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ชื่อสินค้า"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "cl_catalog_name",
                                                                        value: values.cl_catalog_name,
                                                                        className: "form-control",
                                                                        placeholder: "ชื่อสินค้า",
                                                                        onChange: function(e) {
                                                                            setFieldValue("cl_catalog_name", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ชื่อสินค้า (ภาษาอังกฤษ)"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "cl_catalog_nameen",
                                                                        value: values.cl_catalog_nameen || "",
                                                                        className: "form-control",
                                                                        placeholder: "ชื่อสินค้า",
                                                                        onChange: function(e) {
                                                                            setFieldValue("cl_catalog_nameen", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ชื่อสินค้า (ภาษาลาว)"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "text",
                                                                        name: "cl_catalog_namela",
                                                                        value: values.cl_catalog_namela,
                                                                        className: "form-control",
                                                                        placeholder: "ชื่อสินค้า",
                                                                        onChange: function(e) {
                                                                            setFieldValue("cl_catalog_namela", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                productRow.map(function(item, index) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-3 col-md-3",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "Barcode"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "cl_detail_barcode",
                                                                            className: "form-control",
                                                                            placeholder: "กรอก Barcode",
                                                                            value: item.cl_detail_barcode,
                                                                            onChange: function(e) {
                                                                                setProductRow(function(prev) {
                                                                                    return prev.map(function(el) {
                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                            cl_detail_barcode: e.target.value
                                                                                        }) : el;
                                                                                    });
                                                                                });
                                                                            },
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3 sm pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ขนาดบรรจุ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "cl_detail_unitid",
                                                                                className: "w-100 select-st-1",
                                                                                options: optionsUnit,
                                                                                placeholder: "เลือกขนาดบรรจุ",
                                                                                value: optionsUnit.filter(function(d) {
                                                                                    return d.value == item.cl_detail_unitid;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setProductRow(function(prev) {
                                                                                        return prev.map(function(el) {
                                                                                            return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                                cl_detail_unitid: e.value
                                                                                            }) : el;
                                                                                        });
                                                                                    });
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-xl-5",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-2",
                                                                    children: [
                                                                        [
                                                                            1,
                                                                            2,
                                                                            3,
                                                                            4
                                                                        ].map(function(level) {
                                                                            var field = level === 1 ? "cl_detail_wholesale" : "cl_detail_wholesale_level".concat(level);
                                                                            var _item_field;
                                                                            var value = (_item_field = item[field]) !== null && _item_field !== void 0 ? _item_field : "";
                                                                            return /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-6 col-md-3",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: [
                                                                                                "ราคาส่ง Level ",
                                                                                                level,
                                                                                                " (Ex VAT)"
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "number",
                                                                                            min: "0",
                                                                                            step: "0.01",
                                                                                            inputMode: "decimal",
                                                                                            name: field,
                                                                                            className: "form-control",
                                                                                            placeholder: "Level ".concat(level),
                                                                                            value: value,
                                                                                            onChange: function(e) {
                                                                                                var nextValue = e.target.value;
                                                                                                setProductRow(function(prev) {
                                                                                                    return prev.map(function(el) {
                                                                                                        return el.id === item.id ? _object_spread(_object_spread_props(_object_spread({}, el), _define_property({}, field, nextValue)), level === 1 && {
                                                                                                            cl_detail_wholesalevat: nextValue === "" ? "" : Number((Number(nextValue) * 1.1).toFixed(2))
                                                                                                        }) : el;
                                                                                                    });
                                                                                                });
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, level);
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "col-12 text-muted small mb-2",
                                                                            children: [
                                                                                "Level 1 รวมภาษีโดยประมาณ: ",
                                                                                NumberFormat(item.cl_detail_wholesalevat || 0, 2)
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ราคาแนะนำ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "cl_detail_price",
                                                                            className: "form-control",
                                                                            placeholder: "ราคาแนะนำ",
                                                                            value: item.cl_detail_price,
                                                                            onChange: function(e) {
                                                                                setProductRow(function(prev) {
                                                                                    return prev.map(function(el) {
                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                            cl_detail_price: e.target.value
                                                                                        }) : el;
                                                                                    });
                                                                                });
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl col-md",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "แสดง Barcode"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Switch, {
                                                                            checked: item.cl_detail_showbarcode == 1,
                                                                            onChange: function(e) {
                                                                                setProductRow(function(prev) {
                                                                                    return prev.map(function(el) {
                                                                                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                                            cl_detail_showbarcode: e.target.checked ? 1 : 2
                                                                                        }) : el;
                                                                                    });
                                                                                });
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }, index);
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "row gx-xl-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl-12 col-md-12",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ประเภทโปรโมชัน"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                        as: "select",
                                                                        name: "cl_catalog_promotionid",
                                                                        onChange: function(e) {
                                                                            setFieldValue("cl_catalog_promotionid", e.value);
                                                                        },
                                                                        z: true,
                                                                        className: "w-100 select-st-1",
                                                                        options: typePromo,
                                                                        placeholder: "เลือกประเภทโปรโมชัน",
                                                                        value: typePromo.filter(function(item) {
                                                                            return item.value === values.cl_catalog_promotionid;
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "col-xl-3 col-md-12",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-lg text-[#2F4858] mr-auto",
                                                                    children: "ตัวเลือกพิเศษ"
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "flex items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Checkbox, {
                                                                            checked: pdSelling,
                                                                            onChange: function(e) {
                                                                                if (e.target.checked) {
                                                                                    setPdSelling(true);
                                                                                } else {
                                                                                    setPdSelling(false);
                                                                                }
                                                                            },
                                                                            sx: {
                                                                                "& .MuiSvgIcon-root": {
                                                                                    fontSize: 30
                                                                                }
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-lg text-[#2F4858] mr-auto",
                                                                            children: "สินค้าขายดี"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Checkbox, {
                                                                            checked: pdnew,
                                                                            onChange: function(e) {
                                                                                if (e.target.checked) {
                                                                                    setPdNew(true);
                                                                                } else {
                                                                                    setPdNew(false);
                                                                                }
                                                                            },
                                                                            sx: {
                                                                                "& .MuiSvgIcon-root": {
                                                                                    fontSize: 30
                                                                                }
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-lg text-[#2F4858] mr-auto",
                                                                            children: "สินค้ามาใหม่"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "col-xl-3 col-md-12",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "text-lg text-[#2F4858] mr-auto",
                                                                    children: "สถานะ"
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "flex items-center mt-2",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-1",
                                                                                label: "เปิดใช้งาน",
                                                                                checked: type == 1 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                onChange: function() {
                                                                                    setType(1);
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                                inline: true,
                                                                                type: "radio",
                                                                                id: "p-radio-2",
                                                                                label: "ปิดใช้งาน",
                                                                                checked: type == 2 ? true : false,
                                                                                className: "form-check-st-2 tc-7 mt-0",
                                                                                onChange: function() {
                                                                                    setType(2);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, "p-radio")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "col-xl col-md",
                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                className: "mb-2 form-st-3 pb-1",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-1",
                                                                        children: "ลำดับ"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                        type: "number",
                                                                        name: "cl_catalog_orderby",
                                                                        className: "form-control",
                                                                        placeholder: "ลำดับ",
                                                                        value: values.cl_catalog_orderby,
                                                                        onChange: function(e) {
                                                                            setFieldValue("cl_catalog_orderby", e.target.value);
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/clbook/catalog/".concat(dataID), catalogListNavigationOptions);
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ย้อนกลับ"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            onClick: function(e) {
                                                handleSubmit();
                                                e.preventDefault();
                                            },
                                            className: "btn-st-3 me-3",
                                            children: "บันทึก"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: "/clbook/catalog/".concat(dataID),
                navigationOptions: catalogListNavigationOptions
            })
        ]
    });
}
function ProductSelect(_param) {
    var modal = _param.modal, setModal = _param.setModal, hbtn = _param.hbtn, htitle = _param.htitle, row = _param.row, setRow = _param.setRow, productRow = _param.productRow, setProductRow = _param.setProductRow, filteredItems = _param.filteredItems, setFilteredItems = _param.setFilteredItems, optionBrand = _param.optionBrand, setOptionBrand = _param.setOptionBrand, brandId = _param.brandId, setBrandId = _param.setBrandId, modalObj = _param.modalObj, setModalObj = _param.setModalObj, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "hbtn",
        "htitle",
        "row",
        "setRow",
        "productRow",
        "setProductRow",
        "filteredItems",
        "setFilteredItems",
        "optionBrand",
        "setOptionBrand",
        "brandId",
        "setBrandId",
        "modalObj",
        "setModalObj"
    ]);
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var tableFontFamily = '"Sarabun", "Phetsarath", sans-serif';
    var columns = [
        {
            field: "brandName",
            headerName: "แบรนด์",
            minWidth: 120,
            flex: 1,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        children: row.brandName || "-"
                    })
                });
            }
        },
        {
            field: "code",
            headerName: "รหัสสินค้า",
            headerAlign: "center",
            align: "center",
            minWidth: 180,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            color: "#565DFF"
                        },
                        children: row.code || "-"
                    })
                });
            }
        },
        {
            field: "barcode",
            headerName: "บาร์โค้ด",
            minWidth: 120,
            flex: 1,
            sortable: true
        },
        {
            field: "name",
            headerName: "ชื่อสินค้า",
            minWidth: 250,
            flex: 1,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            row.name,
                            /*#__PURE__*/ _jsx("br", {}),
                            /*#__PURE__*/ _jsx("span", {
                                className: "fs-12",
                                style: {
                                    color: "#F26F3A"
                                },
                                children: row.barcode
                            }),
                            " "
                        ]
                    })
                });
            }
        },
        {
            field: "unit",
            headerName: "หน่วย",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: row.unit
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: row.rate
                        })
                    ]
                });
            }
        },
        {
            field: "pricePresent",
            headerName: "ราคาแคตตาล็อก",
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true
        },
        {
            field: "priceRecommended",
            headerName: "ราคาขาย",
            minWidth: 120,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true
        },
        {
            field: "gp",
            headerName: "GP",
            minWidth: 120,
            headerAlign: "center",
            align: "center",
            flex: 1,
            sortable: true
        }
    ];
    useEffect(function() {
        if (filterText) {
            setFilteredItems(row.filter(function(item) {
                return item.code && item.code.toLowerCase().includes(filterText.toLowerCase()) || item.barcode && item.barcode.toLowerCase().includes(filterText.toLowerCase()) || item.name && item.name.toLowerCase().includes(filterText.toLowerCase()) || item.unit && item.unit.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setFilteredItems(row);
        }
    }, [
        row,
        filterText
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-4",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1 z-3",
                                    children: "ค้นหาแบรนด์"
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    className: "w-100 select-st-3 z-2",
                                    placeholder: "ค้นหาแบรนด์",
                                    options: optionBrand,
                                    value: optionBrand.find(function(opt) {
                                        return opt.value === brandId;
                                    }) || "",
                                    onChange: function(e) {
                                        return setBrandId(e ? e.value : "");
                                    },
                                    isClearable: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-4",
                        children: /*#__PURE__*/ _jsx(Form.Group, {
                            className: "mb-2 form-st-3",
                            children: /*#__PURE__*/ _jsx("input", {
                                type: "text",
                                className: "form-control form-st-4 py-2 w-100",
                                placeholder: "ค้นหา",
                                onChange: function(e) {
                                    return setFilterText(e.target.value);
                                },
                                value: filterText
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-2 col-md-4",
                        children: /*#__PURE__*/ _jsx("button", {
                            onClick: function() {
                                setFilterText("");
                            },
                            type: "button",
                            size: "small",
                            className: "w-100 btn btn btn-st-v1 mb-2 px-4 mt-[10px]",
                            children: "ล้างค่าการค้นหา"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DataGrid, {
                getRowId: function(row) {
                    return row.product_id;
                },
                getRowHeight: function() {
                    return "auto";
                },
                rows: filteredItems,
                autoHeight: true,
                columns: columns,
                initialState: {
                    pagination: {
                        paginationModel: {
                            pageSize: 10
                        }
                    }
                },
                pageSizeOptions: [
                    10,
                    20,
                    30
                ],
                checkboxSelection: true,
                rowSelectionModel: productRow.map(function(item) {
                    return item.product_id;
                }),
                disableRowSelectionOnClick: true,
                slotProps: {
                    pagination: {
                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                    }
                },
                // disableMultipleRowSelection={true}
                sx: {
                    fontFamily: tableFontFamily,
                    fontSize: "16px",
                    "& .MuiDataGrid-columnHeaders": {
                        fontFamily: tableFontFamily
                    },
                    ".MuiDataGrid-columnHeaderTitle": {
                        fontFamily: tableFontFamily,
                        fontSize: "16px"
                    },
                    "& .MuiDataGrid-cell": {
                        fontFamily: tableFontFamily
                    },
                    "& .MuiTablePagination-root": {
                        fontFamily: tableFontFamily
                    },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions": {
                        fontFamily: tableFontFamily
                    },
                    "& .MuiDataGrid-virtualScrollerRenderZone": {
                        transform: "unset !important"
                    }
                },
                onRowSelectionModelChange: function(ids) {
                    var _arr;
                    var data = [];
                    var arr = [];
                    (_arr = arr).push.apply(_arr, _to_consumable_array(ids));
                    filteredItems.map(function(ele) {
                        var find = arr.find(function(val) {
                            return val == ele.id;
                        });
                        if (find) {
                            data.push(_object_spread({}, ele));
                        }
                    });
                    setProductRow(data);
                }
            })
        ]
    });
}
export function StatusModal(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID, modelText = param.modelText, setTabStatus = param.setTabStatus, setDataForSearch = param.setDataForSearch, dataForSearch = param.dataForSearch;
    var _modal_data;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(1), 2), type = _useState[0], setType = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), id = _useState1[0], setId = _useState1[1];
    useEffect(function() {
        if (modal.data == null) {
            setType(1);
            setId(0);
        }
        if (modal.data != null) {
            var vul = modal.data;
            setType(vul.status);
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var updateStatusCatalogReducer = useAppSelector(function(state) {
        return state.updateStatusCatalogReducer;
    });
    var updateStatusNewReducer = useAppSelector(function(state) {
        return state.updateStatusNewReducer;
    });
    var updateStatusRecomReducer = useAppSelector(function(state) {
        return state.updateStatusRecomReducer;
    });
    var searchData = useMemo(function() {
        return dataForSearch && Object.keys(dataForSearch).length > 0 ? dataForSearch : {
            bookid: parseInt(dataID)
        };
    }, [
        dataForSearch,
        dataID
    ]);
    useEffect(function() {
        setIsLoading(updateStatusCatalogReducer.isFetching || updateStatusNewReducer.isFetching || updateStatusRecomReducer.isFetching);
        if (modal.open && updateStatusCatalogReducer.data && !updateStatusCatalogReducer.isError) {
            setTextsuccess("เปลี่ยนสถานะสำเร็จ");
            setModalsuccess(true);
            // const data = {
            //   bookid: parseInt(dataID),
            // };
            dispatch(allCatalog(searchData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearupdateStatusCatalog());
            dispatch(clearupdateStatusNew());
            dispatch(clearupdateStatusRecom());
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        // setTabStatus(0);
        }
        if (modal.open && updateStatusNewReducer.data && !updateStatusNewReducer.isError) {
            setTextsuccess("เปลี่ยนสถานะสินค้าใหม่สำเร็จ");
            setModalsuccess(true);
            // const data = {
            //   bookid: parseInt(dataID),
            // };
            dispatch(allCatalog(searchData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearupdateStatusCatalog());
            dispatch(clearupdateStatusNew());
            dispatch(clearupdateStatusRecom());
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        // setTabStatus(0);
        }
        if (modal.open && updateStatusRecomReducer.data && !updateStatusRecomReducer.isError) {
            setTextsuccess("เปลี่ยนสถานะสินค้าขายดีสำเร็จ");
            setModalsuccess(true);
            // const data = {
            //   bookid: parseInt(dataID),
            // };
            dispatch(allCatalog(searchData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(clearupdateStatusCatalog());
            dispatch(clearupdateStatusNew());
            dispatch(clearupdateStatusRecom());
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setType(1);
            setId(0);
        // setTabStatus(0);
        }
    }, [
        dispatch,
        modal.open,
        setIsLoading,
        setModal,
        setModalsuccess,
        setTextsuccess,
        searchData,
        modalObj,
        setModalObj,
        updateStatusCatalogReducer,
        updateStatusNewReducer,
        updateStatusRecomReducer
    ]);
    var onClickModel = function() {
        if (modal.typeData == "status") {
            var data = {
                clcatalogid: id,
                clcatalogstatus: type == 1 ? 2 : 1
            };
            dispatch(updateStatusCatalog(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "new") {
            var data1 = {
                clcatalogid: id,
                clcatalognew: type == 1 ? 2 : 1
            };
            dispatch(updateStatusNew(data1, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "recom") {
            var data2 = {
                clcatalogid: id,
                clcatalogrecom: type == 1 ? 2 : 1
            };
            dispatch(updateStatusRecom(data2, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: [
                        "คุณต้องการเปลี่ยน",
                        modelText,
                        "ข้อมูลนี้"
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataForSearch = param.dataForSearch, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deleteCatalogReducer = useAppSelector(function(state) {
        return state.deleteCatalogReducer;
    });
    useEffect(function() {
        setIsLoading(deleteCatalogReducer.isFetching);
        if (deleteCatalogReducer.data && !deleteCatalogReducer.isError) {
            setTextsuccess("ลบแคตตาล็อคสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteCatalog());
            dispatch(allCatalog(dataForSearch, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteCatalogReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        var data = {
            cl_catalog_id: parseInt(id)
        };
        dispatch(deleteCatalog(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "",
        children: /*#__PURE__*/ _jsxs("center", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
export function DelOpenModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataForSearch = param.dataForSearch, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deleteOpenCatalogReducer = useAppSelector(function(state) {
        return state.deleteOpenCatalogReducer;
    });
    useEffect(function() {
        setIsLoading(deleteOpenCatalogReducer.isFetching);
        if (deleteOpenCatalogReducer.data && !deleteOpenCatalogReducer.isError) {
            setTextsuccess("คืนค่าการลบแคตตาล็อคสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteOpenCatalog());
            dispatch(allCatalog(dataForSearch, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteOpenCatalogReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        var data = {
            cl_catalog_id: parseInt(id)
        };
        dispatch(deleteOpenCatalog(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "",
        children: /*#__PURE__*/ _jsxs("center", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการคืนค่าการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
export function UpdateDetailModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataForSearch = param.dataForSearch, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var updateDetailCatalogReducer = useAppSelector(function(state) {
        return state.updateDetailCatalogReducer;
    });
    useEffect(function() {
        setIsLoading(updateDetailCatalogReducer.isFetching);
        if (updateDetailCatalogReducer.data && !updateDetailCatalogReducer.isError) {
            setTextsuccess("อัพเดทข้อมูลแคตตาล็อคสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateDetailCatalog());
            dispatch(allCatalog(dataForSearch, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        updateDetailCatalogReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        var data = {
            cl_catalog_id: parseInt(id)
        };
        dispatch(updateDetailCatalog(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "",
        children: /*#__PURE__*/ _jsxs("center", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการอัพเดทข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, navigationOptions = _param.navigationOptions, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction",
        "navigationOptions"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction, navigationOptions);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
export function PRPrint(param) {
    var innerRef = param.innerRef, rowData = param.rowData;
    return /*#__PURE__*/ _jsx("div", {
        ref: innerRef,
        children: /*#__PURE__*/ _jsx(PagePrint, {
            rowData: rowData
        })
    });
}
var PagePrint = function(param) {
    var rowData = param.rowData;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "text-[12.5px] text-[#2C2C2C] mb-1 print-page",
            style: {
                width: "210mm",
                minHeight: "297mm",
                padding: "5mm",
                margin: "0 auto",
                background: "white",
                position: "relative"
            },
            children: /*#__PURE__*/ _jsxs("table", {
                className: "print-page",
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ _jsxs("thead", {
                        style: {
                            backgroundColor: "#cc0000",
                            color: "white"
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        rowSpan: "2",
                                        children: "ชื่อสินค้า"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        rowSpan: "2",
                                        children: "Barcode"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        rowSpan: "2",
                                        children: "ขนาดบรรจุ"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-right",
                                        rowSpan: "2",
                                        children: "ราคาแนะนำขาย"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        colSpan: "2",
                                        children: "ราคาขายส่ง"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        rowSpan: "2",
                                        children: "โปรโมชัน"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("tr", {
                                children: [
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        children: "Ex Vat"
                                    }),
                                    /*#__PURE__*/ _jsx("th", {
                                        className: "py-2 text-center",
                                        children: "In Vat"
                                    })
                                ]
                            })
                        ]
                    }),
                    rowData.length > 0 && /*#__PURE__*/ _jsx("tbody", {
                        children: rowData.map(function(row, i) {
                            return /*#__PURE__*/ _jsxs("tr", {
                                style: {
                                    borderBottom: "1px solid #d2d2d2"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("td", {
                                        style: {
                                            width: "130px"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                justifyContent: "flex-start",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "me-4 mt-2",
                                                        children: [
                                                            i + 1,
                                                            "."
                                                        ]
                                                    }),
                                                    row.cl_catalog_image ? /*#__PURE__*/ _jsx("img", {
                                                        src: row.cl_catalog_image,
                                                        className: "mt-2",
                                                        alt: "สินค้า",
                                                        loading: "lazy",
                                                        decoding: "async",
                                                        style: {
                                                            width: 80,
                                                            height: 80
                                                        }
                                                    }) : ""
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "mb-[10px] text-left mt-2",
                                                children: [
                                                    row.cl_catalog_name,
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "tc-7 fs-10",
                                                        children: row.cl_catalog_namela
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center",
                                        style: {
                                            width: "80px"
                                        },
                                        children: row.ClDetail.map(function(ele, index) {
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: "text-center mb-[18px]",
                                                children: ele.cl_detail_barcode
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "text-center",
                                        style: {
                                            width: "80px"
                                        },
                                        children: row.ClDetail.map(function(ele, index) {
                                            var _ele_SetUnit;
                                            return /*#__PURE__*/ _jsxs("div", {
                                                className: "text-left ml-2 ".concat(ele.cl_detail_ratiooption ? "mb-[0px]" : "mb-[18px]"),
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: ((_ele_SetUnit = ele.SetUnit) === null || _ele_SetUnit === void 0 ? void 0 : _ele_SetUnit.set_unit_name) ? " ".concat(ele.SetUnit.set_unit_name, " =") : ""
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: ele.cl_detail_ratio ? " ".concat(ele.cl_detail_ratio) : ""
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: ele.cl_detail_ratio ? " ชิ้น" : ""
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        children: ele.cl_detail_ratiooption ? " / ".concat(ele.cl_detail_ratiooption, " แพ็ค") : ""
                                                    })
                                                ]
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        style: {
                                            width: "90px"
                                        },
                                        children: row.ClDetail.map(function(ele, index) {
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: "text-right mb-[18px]",
                                                children: NumberFormat(ele.cl_detail_price, 2)
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "pl-2",
                                        style: {
                                            width: "90px"
                                        },
                                        children: row.ClDetail.map(function(ele, index) {
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: "".concat(ele.cl_detail_wholesaledis ? "mb-[5px]" : "mb-[15px]"),
                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        ele.cl_detail_discount ? /*#__PURE__*/ _jsxs("span", {
                                                            class: "price-tag ml-2 me-2",
                                                            style: {
                                                                color: "#ffffff"
                                                            },
                                                            children: [
                                                                ele.cl_detail_discount,
                                                                row.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("span", {}),
                                                        ele.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs("span", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    style: {
                                                                        color: "#b00312"
                                                                    },
                                                                    children: NumberFormat(ele.cl_detail_wholesaledis ? ele.cl_detail_wholesaledis : 0, 2)
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    class: "old-price",
                                                                    children: NumberFormat(ele.cl_detail_wholesale ? ele.cl_detail_wholesale : 0, 2)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("span", {
                                                            style: ele.cl_detail_unitid == 6 ? {
                                                                color: "#ffffff00"
                                                            } : {
                                                                color: "#212529"
                                                            },
                                                            children: NumberFormat(ele.cl_detail_wholesale ? ele.cl_detail_wholesale : 0, 2)
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        className: "pr-2",
                                        style: {
                                            width: "90px"
                                        },
                                        children: row.ClDetail.map(function(ele, index) {
                                            return /*#__PURE__*/ _jsx("div", {
                                                className: "".concat(ele.cl_detail_wholesalevatdis ? "mb-[5px]" : "mb-[15px]"),
                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        ele.cl_detail_discount ? /*#__PURE__*/ _jsxs("span", {
                                                            class: "price-tag ml-2 me-2",
                                                            style: {
                                                                color: "#ffffff"
                                                            },
                                                            children: [
                                                                ele.cl_detail_discount,
                                                                row.SetPromotion.set_promotion_type == 1 ? "฿" : "%"
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("span", {}),
                                                        ele.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs("span", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    style: {
                                                                        color: "#b00312"
                                                                    },
                                                                    children: NumberFormat(ele.cl_detail_wholesalevatdis ? ele.cl_detail_wholesalevatdis : 0, 2)
                                                                }),
                                                                /*#__PURE__*/ _jsx("p", {
                                                                    class: "old-price",
                                                                    children: NumberFormat(ele.cl_detail_wholesalevat ? ele.cl_detail_wholesalevat : 0, 2)
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ _jsx("span", {
                                                            style: ele.cl_detail_unitid == 6 ? {
                                                                color: "#ffffff00"
                                                            } : {
                                                                color: "#212529"
                                                            },
                                                            children: NumberFormat(ele.cl_detail_wholesalevat ? ele.cl_detail_wholesalevat : 0, 2)
                                                        })
                                                    ]
                                                })
                                            }, index);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("td", {
                                        style: {
                                            width: "100px"
                                        },
                                        children: row.SetPromotion ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mb-[10px] text-center",
                                                    children: row.SetPromotion.set_promotion_name
                                                }),
                                                row.SetPromotion.set_promotion_type == 3 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-[10px] text-center",
                                                            children: row.SetPromotion.set_promotion_buy && row.SetPromotion.set_promotion_free && /*#__PURE__*/ _jsxs("span", {
                                                                className: "!bg-[#0012fd] text-white px-2 pt-1 pb-2 fs-12",
                                                                style: {
                                                                    borderRadius: 10
                                                                },
                                                                children: [
                                                                    row.SetPromotion.set_promotion_buy ? "".concat(row.SetPromotion.set_promotion_buy, " +") : "",
                                                                    row.SetPromotion.set_promotion_free ? "".concat(row.SetPromotion.set_promotion_free) : ""
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-[10px] text-center",
                                                            style: {
                                                                color: "#0012fd"
                                                            },
                                                            children: row.ClDetail.map(function(ele, index) {
                                                                return /*#__PURE__*/ _jsx(_Fragment, {
                                                                    children: ele.cl_detail_wholesaleavg ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                children: "เฉลี่ยแพ็คละ"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("p", {
                                                                                children: ele.cl_detail_wholesaleavg
                                                                            })
                                                                        ]
                                                                    }) : ""
                                                                });
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "mb-[10px] text-center",
                                                    children: [
                                                        moment(row.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                        " ",
                                                        "-",
                                                        " ",
                                                        moment(row.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ _jsx("center", {
                                            children: "-"
                                        })
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            })
        })
    });
};
// Styles
var styles = StyleSheet.create({
    page: {
        padding: 10,
        fontSize: 12,
        color: "#2C2C2C",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    headerRow: {
        flexDirection: "row",
        backgroundColor: "#cc0000",
        color: "white",
        fontWeight: "bold",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    headerCell: {
        justifyContent: "center",
        alignItems: "center",
        // padding: 4,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    headerText: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "center"
    },
    topHeaderText: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "center"
    },
    row: {
        flexDirection: "row",
        borderBottom: "1px solid #d2d2d2"
    },
    rowName: {
        flexDirection: "row"
    },
    cell: {
        // flex: 1,
        fontSize: 10,
        padding: 4,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    textNameLao: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 10,
        marginLeft: 10,
        color: "rgba(76, 78, 100, 0.87)"
    },
    textCenter: {
        textAlign: "center"
    },
    textRight: {
        textAlign: "right"
    },
    textPromotionFree: {
        backgroundColor: "#0012fd",
        color: "white",
        paddingVertical: 2,
        paddingHorizontal: 4,
        borderRadius: 10,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    textPromotionWholesale: {
        color: "#0012fd",
        paddingVertical: 2,
        paddingHorizontal: 4,
        fontWeight: "bold",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    image: {
        width: 90,
        height: "auto",
        marginRight: 0
    },
    pdfImageCell: {
        width: "100%",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center"
    },
    section: {
        marginBottom: 12
    },
    header: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start"
    },
    pdfHeaderRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        position: "relative",
        minHeight: 20
    },
    pdfHeaderTitle: {
        paddingRight: 80
    },
    pdfHeaderLogoWrap: {
        position: "absolute",
        top: 0,
        right: 0,
        alignItems: "flex-end",
        justifyContent: "flex-start"
    },
    pdfTopLogoWrap: {
        position: "absolute",
        top: 10,
        right: 10,
        alignItems: "flex-end",
        justifyContent: "flex-start"
    },
    logo: {
        width: 100,
        height: 61,
        marginBottom: 5
    },
    textHeaderCompany: {
        fontSize: 18,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold",
        marginBottom: 1
    },
    textDetailCompany: {
        fontSize: 16,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    centerHeaderText: {
        textAlign: "center",
        marginVertical: 12,
        fontSize: 18,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontWeight: "bold"
    },
    rightDetailText: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 16,
        textAlign: "right"
    },
    paragraph: {
        fontSize: 16,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginVertical: 15
    },
    bold: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 16,
        fontWeight: "bold"
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 20,
        right: 20,
        textAlign: "right",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 16,
        fontWeight: "bold"
    },
    sectionHeader: {
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        fontSize: 16,
        fontWeight: "bold"
    },
    paragraphSignature: {
        fontSize: 16,
        lineHeight: 1.2,
        textAlign: "justify",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginVertical: 40
    },
    paragraphTextC: {
        fontSize: 16,
        lineHeight: 1.2,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginBottom: 1
    },
    paddingLeftTextS1: {
        paddingLeft: 40
    },
    paddingLeftTextS2: {
        paddingLeft: 60
    },
    signatureRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20,
        marginVertical: 40
    },
    signatureRow2: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingHorizontal: 20
    },
    signatureBox: {
        minWidth: "45%",
        alignItems: "center"
    },
    signatureLine: {
        fontSize: 16,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginBottom: 4,
        textAlign: "center",
        fontWeight: "bold"
    },
    signatureName: {
        fontSize: 16,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        textAlign: "center",
        fontWeight: "bold"
    },
    paragraphPadding_40: {
        fontSize: 16,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginVertical: 5,
        paddingLeft: 40
    },
    channelRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingLeft: 100,
        marginVertical: 10
    },
    channelBox: {
        minWidth: "45%",
        alignItems: "start"
    },
    channelLine: {
        fontSize: 16,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        marginBottom: 4,
        textAlign: "left"
    },
    channelName: {
        fontSize: 16,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        textAlign: "left"
    },
    table: {
        display: "flex",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        borderBottomWidth: 0
    },
    tableRow: {
        flexDirection: "row"
    },
    tableColHeader: {
        //width: '25%',
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5
    },
    tableCol: {
        //width: '25%',
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5
    },
    tableCellHeader: {
        fontSize: 14,
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    },
    tableCell: {
        fontSize: 12,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ],
        justifyContent: "center"
    },
    tableCol5P: {
        width: "5%"
    },
    tableCol10P: {
        width: "10%"
    },
    tableCol15P: {
        width: "15%"
    },
    tableCol20P: {
        width: "20%"
    },
    tableCol25P: {
        width: "25%"
    },
    tableCol30P: {
        width: "30%"
    },
    tableCol35P: {
        width: "35%"
    },
    tableCol40P: {
        width: "40%"
    },
    tableCol45P: {
        width: "45%"
    },
    tableCol50P: {
        width: "50%"
    },
    boxInfoPartner: {
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: 60
    },
    pageNumber: {
        position: "absolute",
        bottom: 20,
        right: 30,
        fontSize: 12,
        fontFamily: [
            "Sarabun",
            "Phetsarath"
        ]
    }
});
// ฟอนต์ภาษาไทย
Font.register({
    family: "Sarabun",
    fonts: [
        {
            src: sarabun
        },
        {
            src: sarabunBold,
            fontWeight: "bold"
        }
    ]
});
Font.register({
    family: "Phetsarath",
    fonts: [
        {
            src: phetsarath
        },
        {
            src: phetsarathBold,
            fontWeight: "bold"
        }
    ]
});
function NumberFormatPDF(value) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-US";
    var num = Number(value) || 0;
    return num.toLocaleString(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
}
var sortCatalogRowsByBrand = function() {
    var rows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return Array.isArray(rows) ? rows.filter(Boolean) : [];
};
var isPromotionPdfHeader = function(headerTitle) {
    return String(headerTitle || "").includes("สินค้าโปรโมชั่น") || String(headerTitle || "").includes("ສິນຄ້າໂປຣໂມຊັ່ນ");
};
var getPdfHeaderTitleStyle = function(headerTitle) {
    return [
        styles.topHeaderText,
        isPromotionPdfHeader(headerTitle) ? {
            color: "#b00412"
        } : null
    ];
};
var getCatalogPdfLogoSrc = function() {
    var logoPath = "/images/pardesco-logo-new-red-200.png";
    if (typeof window === "undefined") {
        return logoPath;
    }
    return "".concat(window.location.origin).concat(logoPath);
};
var normalizeCatalogPdfImage = function(imageSrc) {
    if (typeof imageSrc !== "string") {
        return null;
    }
    var trimmedImageSrc = imageSrc.trim();
    var normalizedImageSrc = trimmedImageSrc.toLowerCase();
    if (trimmedImageSrc === "" || normalizedImageSrc === "undefined" || normalizedImageSrc === "null") {
        return null;
    }
    if (trimmedImageSrc.startsWith("/")) {
        if (typeof window === "undefined") {
            return trimmedImageSrc;
        }
        return "".concat(window.location.origin).concat(trimmedImageSrc);
    }
    if (trimmedImageSrc.startsWith("http://") || trimmedImageSrc.startsWith("https://") || trimmedImageSrc.startsWith("data:") || trimmedImageSrc.startsWith("blob:")) {
        return trimmedImageSrc;
    }
    return null;
};
var normalizeCatalogPdfRows = function() {
    var rows = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return Array.isArray(rows) ? rows.filter(Boolean).filter(function(row) {
        return Number(row === null || row === void 0 ? void 0 : row.pd_product_continue) === 1;
    }).map(function(row) {
        return {
            cl_catalog_id: row === null || row === void 0 ? void 0 : row.cl_catalog_id,
            cl_catalog_image: normalizeCatalogPdfImage(row === null || row === void 0 ? void 0 : row.cl_catalog_image),
            cl_catalog_name: row === null || row === void 0 ? void 0 : row.cl_catalog_name,
            cl_catalog_nameen: row === null || row === void 0 ? void 0 : row.cl_catalog_nameen,
            cl_catalog_namela: row === null || row === void 0 ? void 0 : row.cl_catalog_namela,
            cl_catalog_brandid: row === null || row === void 0 ? void 0 : row.cl_catalog_brandid,
            cl_catalog_promotionid: row === null || row === void 0 ? void 0 : row.cl_catalog_promotionid,
            SetPromotion: (row === null || row === void 0 ? void 0 : row.SetPromotion) ? {
                set_promotion_id: row.SetPromotion.set_promotion_id,
                set_promotion_name: row.SetPromotion.set_promotion_name,
                set_promotion_type: row.SetPromotion.set_promotion_type,
                set_promotion_buy: row.SetPromotion.set_promotion_buy,
                set_promotion_free: row.SetPromotion.set_promotion_free,
                set_promotion_sdate: row.SetPromotion.set_promotion_sdate,
                set_promotion_edate: row.SetPromotion.set_promotion_edate
            } : null,
            ClDetail: Array.isArray(row === null || row === void 0 ? void 0 : row.ClDetail) ? row.ClDetail.filter(Boolean).map(function(detail) {
                var _detail_SetUnit, _detail_SetUnit1;
                return {
                    cl_detail_barcode: detail === null || detail === void 0 ? void 0 : detail.cl_detail_barcode,
                    cl_detail_ratio: detail === null || detail === void 0 ? void 0 : detail.cl_detail_ratio,
                    cl_detail_ratiooption: detail === null || detail === void 0 ? void 0 : detail.cl_detail_ratiooption,
                    cl_detail_unitid: detail === null || detail === void 0 ? void 0 : detail.cl_detail_unitid,
                    cl_detail_price: detail === null || detail === void 0 ? void 0 : detail.cl_detail_price,
                    cl_detail_discount: detail === null || detail === void 0 ? void 0 : detail.cl_detail_discount,
                    cl_detail_wholesale: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesale,
                    cl_detail_wholesale_level2: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesale_level2,
                    cl_detail_wholesale_level3: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesale_level3,
                    cl_detail_wholesale_level4: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesale_level4,
                    cl_detail_wholesalevat: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesalevat,
                    cl_detail_wholesaledis: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesaledis,
                    cl_detail_wholesalevatdis: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesalevatdis,
                    cl_detail_wholesaleavg: detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesaleavg,
                    SetUnit: {
                        set_unit_name: detail === null || detail === void 0 ? void 0 : (_detail_SetUnit = detail.SetUnit) === null || _detail_SetUnit === void 0 ? void 0 : _detail_SetUnit.set_unit_name,
                        set_unit_namela: detail === null || detail === void 0 ? void 0 : (_detail_SetUnit1 = detail.SetUnit) === null || _detail_SetUnit1 === void 0 ? void 0 : _detail_SetUnit1.set_unit_namela
                    }
                };
            }) : []
        };
    }) : [];
};
var applyCatalogPrintPriceLevel = function(rows, priceLevel) {
    var level = Math.min(4, Math.max(1, Number(priceLevel) || 1));
    var levelField = level === 1 ? "cl_detail_wholesale" : "cl_detail_wholesale_level".concat(level);
    return rows.map(function(row) {
        var _row_SetPromotion, _row_SetPromotion1, _row_SetPromotion2;
        var promotionType = Number(row === null || row === void 0 ? void 0 : (_row_SetPromotion = row.SetPromotion) === null || _row_SetPromotion === void 0 ? void 0 : _row_SetPromotion.set_promotion_type);
        var promotionBuy = Number(row === null || row === void 0 ? void 0 : (_row_SetPromotion1 = row.SetPromotion) === null || _row_SetPromotion1 === void 0 ? void 0 : _row_SetPromotion1.set_promotion_buy) || 0;
        var promotionFree = Number(row === null || row === void 0 ? void 0 : (_row_SetPromotion2 = row.SetPromotion) === null || _row_SetPromotion2 === void 0 ? void 0 : _row_SetPromotion2.set_promotion_free) || 0;
        return _object_spread_props(_object_spread({}, row), {
            ClDetail: row.ClDetail.map(function(detail) {
                var _detail_levelField, _ref;
                var wholesale = Number((_ref = (_detail_levelField = detail === null || detail === void 0 ? void 0 : detail[levelField]) !== null && _detail_levelField !== void 0 ? _detail_levelField : detail === null || detail === void 0 ? void 0 : detail.cl_detail_wholesale) !== null && _ref !== void 0 ? _ref : 0) || 0;
                var wholesalevat = Number((wholesale * 1.1).toFixed(2));
                var discount = Number(detail === null || detail === void 0 ? void 0 : detail.cl_detail_discount) || 0;
                var wholesaledis = 0;
                var wholesalevatdis = 0;
                var wholesaleavg = 0;
                if (promotionType === 1 && discount > 0) {
                    wholesaledis = wholesale - discount;
                } else if (promotionType === 2 && discount > 0) {
                    wholesaledis = wholesale - wholesale * discount / 100;
                } else if (promotionType === 3 && Number(detail === null || detail === void 0 ? void 0 : detail.cl_detail_unitid) === 4 && promotionBuy + promotionFree > 0) {
                    wholesaleavg = Number((wholesale * promotionBuy / (promotionBuy + promotionFree)).toFixed(2));
                }
                if (wholesaledis > 0) {
                    wholesalevatdis = Number((wholesaledis * 1.1).toFixed(2));
                }
                return _object_spread_props(_object_spread({}, detail), {
                    cl_detail_wholesale: wholesale,
                    cl_detail_wholesalevat: wholesalevat,
                    cl_detail_wholesaledis: wholesaledis,
                    cl_detail_wholesalevatdis: wholesalevatdis,
                    cl_detail_wholesaleavg: wholesaleavg
                });
            })
        });
    });
};
// PDF Template Component TH
function CatalogDocument(_param) {
    var bookInfo = _param.bookInfo, rowData = _param.rowData, _param_headerTitle = _param.headerTitle, headerTitle = _param_headerTitle === void 0 ? "" : _param_headerTitle, props = _object_without_properties(_param, [
        "bookInfo",
        "rowData",
        "headerTitle"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var sortedRowData = sortCatalogRowsByBrand(rowData);
    var logoSrc = getCatalogPdfLogoSrc();
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                headerTitle ? /*#__PURE__*/ _jsx(Text, {
                    fixed: true,
                    style: getPdfHeaderTitleStyle(headerTitle),
                    children: headerTitle
                }) : null,
                isPromotionPdfHeader(headerTitle) ? /*#__PURE__*/ _jsx(View, {
                    fixed: true,
                    style: styles.pdfTopLogoWrap,
                    children: /*#__PURE__*/ _jsx(Image, {
                        cache: true,
                        src: logoSrc,
                        style: {
                            width: 60,
                            height: 15
                        }
                    })
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.pdfHeaderRow,
                    fixed: true,
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            style: [
                                styles.headerCell,
                                styles.pdfHeaderTitle,
                                {
                                    forntSize: 18
                                }
                            ],
                            children: [
                                bookInfo.cl_book_code ? bookInfo.cl_book_code : "",
                                " ",
                                bookInfo.cl_book_name ? bookInfo.cl_book_name : "",
                                " ประจำวันที่ :",
                                " ",
                                bookInfo.cl_book_day != null ? moment(bookInfo.cl_book_day).format("DD/MM/YYYY") : ""
                            ]
                        }),
                        !isPromotionPdfHeader(headerTitle) ? /*#__PURE__*/ _jsx(View, {
                            style: styles.pdfHeaderLogoWrap,
                            children: /*#__PURE__*/ _jsx(Image, {
                                cache: true,
                                src: logoSrc,
                                style: {
                                    width: 60,
                                    height: 15
                                }
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    fixed: true,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.headerRow,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 80
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ชื่อสินค้า"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 115
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "Barcode"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 95
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ขนาดบรรจุ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 120
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ราคาแนะนำขายย"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    width: 160,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: 4
                                        },
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.headerText,
                                            children: "ราคาขายส่ง"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            flexDirection: "row"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(View, {
                                                style: {
                                                    width: 80,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: 4
                                                },
                                                children: /*#__PURE__*/ _jsx(Text, {
                                                    style: styles.headerText,
                                                    children: "Ex Vat"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(View, {
                                                style: {
                                                    width: 80,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: 4
                                                },
                                                children: /*#__PURE__*/ _jsx(Text, {
                                                    style: styles.headerText,
                                                    children: "In Vat"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 120,
                                        borderRightWidth: 0
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "โปรโมชัน"
                                })
                            })
                        ]
                    })
                }),
                sortedRowData.length > 0 && /*#__PURE__*/ _jsx(_Fragment, {
                    children: sortedRowData.map(function(row, i) {
                        var previousRow = sortedRowData[i - 1];
                        var _previousRow_cl_catalog_brandid, _row_cl_catalog_brandid;
                        var shouldBreakPage = i > 0 && String((_previousRow_cl_catalog_brandid = previousRow === null || previousRow === void 0 ? void 0 : previousRow.cl_catalog_brandid) !== null && _previousRow_cl_catalog_brandid !== void 0 ? _previousRow_cl_catalog_brandid : "") !== String((_row_cl_catalog_brandid = row === null || row === void 0 ? void 0 : row.cl_catalog_brandid) !== null && _row_cl_catalog_brandid !== void 0 ? _row_cl_catalog_brandid : "");
                        return /*#__PURE__*/ _jsxs(View, {
                            break: shouldBreakPage,
                            wrap: false,
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: [
                                        styles.rowName,
                                        {
                                            alignItems: "center"
                                        }
                                    ],
                                    wrap: false,
                                    children: /*#__PURE__*/ _jsxs(View, {
                                        style: [
                                            styles.cell,
                                            {
                                                width: "100%"
                                            }
                                        ],
                                        children: [
                                            /*#__PURE__*/ _jsxs(Text, {
                                                children: [
                                                    i + 1,
                                                    ". ",
                                                    row.cl_catalog_name
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.textNameLao,
                                                children: row.cl_catalog_nameen || ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: [
                                        styles.row,
                                        {
                                            alignItems: "center"
                                        }
                                    ],
                                    wrap: false,
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 80
                                                }
                                            ],
                                            children: /*#__PURE__*/ _jsx(View, {
                                                style: styles.pdfImageCell,
                                                children: row.cl_catalog_image != null && row.cl_catalog_image != "" && row.cl_catalog_image != undefined && /*#__PURE__*/ _jsx(Image, {
                                                    cache: true,
                                                    src: row.cl_catalog_image,
                                                    style: styles.image
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 115
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textCenter,
                                                            children: ele.cl_detail_barcode
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textCenter,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 95
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                var _ele_SetUnit;
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Text, {
                                                            children: [
                                                                ((_ele_SetUnit = ele.SetUnit) === null || _ele_SetUnit === void 0 ? void 0 : _ele_SetUnit.set_unit_name) ? "".concat(ele.SetUnit.set_unit_name, " = ") : "",
                                                                ele.cl_detail_ratio || "",
                                                                " ",
                                                                ele.cl_detail_ratio ? "ชิ้น" : "",
                                                                ele.cl_detail_ratiooption ? " / ".concat(ele.cl_detail_ratiooption, " แพ็ค") : ""
                                                            ]
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textCenter,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 120
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                var _row_SetPromotion;
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        ele.cl_detail_discount ? /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: /*#__PURE__*/ _jsxs(View, {
                                                                style: {
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(View, {
                                                                        style: {
                                                                            backgroundColor: "#e68e99",
                                                                            borderRadius: 6,
                                                                            paddingVertical: 2,
                                                                            paddingHorizontal: 4
                                                                        },
                                                                        children: /*#__PURE__*/ _jsxs(Text, {
                                                                            style: {
                                                                                textAlign: "center",
                                                                                color: "white",
                                                                                fontSize: 10,
                                                                                fontFamily: [
                                                                                    "Sarabun",
                                                                                    "Phetsarath"
                                                                                ],
                                                                                fontWeight: "bold"
                                                                            },
                                                                            children: [
                                                                                ele.cl_detail_discount ? "".concat(ele.cl_detail_discount, " ") : "",
                                                                                ((_row_SetPromotion = row.SetPromotion) === null || _row_SetPromotion === void 0 ? void 0 : _row_SetPromotion.set_promotion_type) == 1 ? "฿" : "%"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Text, {
                                                                        style: styles.textRight,
                                                                        children: NumberFormatPDF(ele.cl_detail_price || 0)
                                                                    }, idx)
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: /*#__PURE__*/ _jsx(Text, {
                                                                style: styles.textRight,
                                                                children: NumberFormatPDF(ele.cl_detail_price || 0)
                                                            }, idx)
                                                        }),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 80
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                return ele.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#b00312"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesaledis || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#999",
                                                                    textDecoration: "line-through"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesale || 0)
                                                        }, idx)
                                                    ]
                                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: NumberFormatPDF(ele.cl_detail_wholesale || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 80
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                return ele.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#b00312"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesalevatdis || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#999",
                                                                    textDecoration: "line-through"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesalevat || 0)
                                                        }, idx)
                                                    ]
                                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: NumberFormatPDF(ele.cl_detail_wholesalevat || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 120
                                                }
                                            ],
                                            children: row.SetPromotion ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(Text, {
                                                        style: styles.textCenter,
                                                        children: row.SetPromotion.set_promotion_name
                                                    }),
                                                    /*#__PURE__*/ _jsx(View, {
                                                        style: {
                                                            flexDirection: "row",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        },
                                                        children: row.SetPromotion.set_promotion_type == 3 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Text, {
                                                                    style: [
                                                                        styles.textCenter,
                                                                        styles.textPromotionFree
                                                                    ],
                                                                    children: [
                                                                        row.SetPromotion.set_promotion_buy ? "".concat(row.SetPromotion.set_promotion_buy, " +") : "",
                                                                        row.SetPromotion.set_promotion_free ? "".concat(row.SetPromotion.set_promotion_free) : ""
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    style: [
                                                                        styles.textCenter,
                                                                        styles.textPromotionWholesale
                                                                    ],
                                                                    children: row.ClDetail.map(function(ele, index) {
                                                                        return /*#__PURE__*/ _jsx(_Fragment, {
                                                                            children: ele.cl_detail_wholesaleavg ? /*#__PURE__*/ _jsx(_Fragment, {
                                                                                children: "เฉลี่ยแพ็คละ\n" + ele.cl_detail_wholesaleavg
                                                                            }) : ""
                                                                        });
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Text, {
                                                        style: styles.textCenter,
                                                        children: [
                                                            moment(row.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                            " ",
                                                            "-",
                                                            " ",
                                                            moment(row.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: styles.textCenter,
                                                children: "-"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, "".concat(row.cl_catalog_id || "catalog", "-").concat(i));
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fixed: true,
                    style: styles.pageNumber,
                    render: function(param) {
                        var pageNumber = param.pageNumber, totalPages = param.totalPages;
                        return "".concat(pageNumber, " / ").concat(totalPages);
                    }
                })
            ]
        })
    });
}
// PDF Template Component LA
function CatalogDocumentLao(_param) {
    var bookInfo = _param.bookInfo, rowData = _param.rowData, _param_headerTitle = _param.headerTitle, headerTitle = _param_headerTitle === void 0 ? "" : _param_headerTitle, props = _object_without_properties(_param, [
        "bookInfo",
        "rowData",
        "headerTitle"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var sortedRowData = sortCatalogRowsByBrand(rowData);
    var logoSrc = getCatalogPdfLogoSrc();
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                headerTitle ? /*#__PURE__*/ _jsx(Text, {
                    fixed: true,
                    style: getPdfHeaderTitleStyle(headerTitle),
                    children: headerTitle
                }) : null,
                isPromotionPdfHeader(headerTitle) ? /*#__PURE__*/ _jsx(View, {
                    fixed: true,
                    style: styles.pdfTopLogoWrap,
                    children: /*#__PURE__*/ _jsx(Image, {
                        cache: true,
                        src: logoSrc,
                        style: {
                            width: 70,
                            height: 20
                        }
                    })
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.pdfHeaderRow,
                    fixed: true,
                    children: [
                        /*#__PURE__*/ _jsxs(Text, {
                            style: [
                                styles.headerCell,
                                styles.pdfHeaderTitle,
                                {
                                    forntSize: 18
                                }
                            ],
                            children: [
                                bookInfo.cl_book_code ? bookInfo.cl_book_code : "",
                                " ",
                                bookInfo.cl_book_name ? bookInfo.cl_book_name : "",
                                " ປະຈຳວັນທີ່ :",
                                " ",
                                bookInfo.cl_book_day != null ? moment(bookInfo.cl_book_day).format("DD/MM/YYYY") : ""
                            ]
                        }),
                        !isPromotionPdfHeader(headerTitle) ? /*#__PURE__*/ _jsx(View, {
                            style: styles.pdfHeaderLogoWrap,
                            children: /*#__PURE__*/ _jsx(Image, {
                                cache: true,
                                src: logoSrc,
                                style: {
                                    width: 70,
                                    height: 20
                                }
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    fixed: true,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.headerRow,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 80
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ຊື່ສິນຄ້າ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 115
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ບາໂຄດ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 95
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ຂະໜາດບັນຈຸ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 120
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ລາຄາແນະນຳຂາຍ"
                                })
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    width: 160,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: 4
                                        },
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            style: styles.headerText,
                                            children: "ລາຄາຂາຍສົ່ງ"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            flexDirection: "row"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(View, {
                                                style: {
                                                    width: 80,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: 4
                                                },
                                                children: /*#__PURE__*/ _jsx(Text, {
                                                    style: styles.headerText,
                                                    children: "Ex Vat"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(View, {
                                                style: {
                                                    width: 80,
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: 4
                                                },
                                                children: /*#__PURE__*/ _jsx(Text, {
                                                    style: styles.headerText,
                                                    children: "In Vat"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: [
                                    styles.headerCell,
                                    {
                                        width: 120,
                                        borderRightWidth: 0
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: styles.headerText,
                                    children: "ໂປຣໂມຊັນ"
                                })
                            })
                        ]
                    })
                }),
                sortedRowData.length > 0 && /*#__PURE__*/ _jsx(_Fragment, {
                    children: sortedRowData.map(function(row, i) {
                        var previousRow = sortedRowData[i - 1];
                        var _previousRow_cl_catalog_brandid, _row_cl_catalog_brandid;
                        var shouldBreakPage = i > 0 && String((_previousRow_cl_catalog_brandid = previousRow === null || previousRow === void 0 ? void 0 : previousRow.cl_catalog_brandid) !== null && _previousRow_cl_catalog_brandid !== void 0 ? _previousRow_cl_catalog_brandid : "") !== String((_row_cl_catalog_brandid = row === null || row === void 0 ? void 0 : row.cl_catalog_brandid) !== null && _row_cl_catalog_brandid !== void 0 ? _row_cl_catalog_brandid : "");
                        return /*#__PURE__*/ _jsxs(View, {
                            break: shouldBreakPage,
                            wrap: false,
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: [
                                        styles.rowName,
                                        {
                                            alignItems: "center"
                                        }
                                    ],
                                    wrap: false,
                                    children: /*#__PURE__*/ _jsxs(View, {
                                        style: [
                                            styles.cell,
                                            {
                                                width: "100%"
                                            }
                                        ],
                                        children: [
                                            /*#__PURE__*/ _jsxs(Text, {
                                                children: [
                                                    i + 1,
                                                    ". ",
                                                    row.cl_catalog_namela
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: styles.textNameLao,
                                                children: row.cl_catalog_nameen || ""
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: [
                                        styles.row,
                                        {
                                            alignItems: "center"
                                        }
                                    ],
                                    wrap: false,
                                    children: [
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 80
                                                }
                                            ],
                                            children: /*#__PURE__*/ _jsx(View, {
                                                style: styles.pdfImageCell,
                                                children: row.cl_catalog_image != null && row.cl_catalog_image != "" && row.cl_catalog_image != undefined && /*#__PURE__*/ _jsx(Image, {
                                                    cache: true,
                                                    src: row.cl_catalog_image,
                                                    style: styles.image
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 115
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textCenter,
                                                            children: ele.cl_detail_barcode
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textCenter,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 95
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                var _ele_SetUnit;
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Text, {
                                                            children: [
                                                                ((_ele_SetUnit = ele.SetUnit) === null || _ele_SetUnit === void 0 ? void 0 : _ele_SetUnit.set_unit_namela) ? "".concat(ele.SetUnit.set_unit_namela, " = ") : "",
                                                                ele.cl_detail_ratio || "",
                                                                " ",
                                                                ele.cl_detail_ratio ? "ຊິ້ນ" : "",
                                                                ele.cl_detail_ratiooption ? " / ".concat(ele.cl_detail_ratiooption, " ແພັກ") : ""
                                                            ]
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textCenter,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 120
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                var _row_SetPromotion;
                                                return /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        ele.cl_detail_discount ? /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: /*#__PURE__*/ _jsxs(View, {
                                                                style: {
                                                                    flexDirection: "row",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(View, {
                                                                        style: {
                                                                            backgroundColor: "#e68e99",
                                                                            borderRadius: 6,
                                                                            paddingVertical: 2,
                                                                            paddingHorizontal: 4
                                                                        },
                                                                        children: /*#__PURE__*/ _jsxs(Text, {
                                                                            style: {
                                                                                textAlign: "center",
                                                                                color: "white",
                                                                                fontSize: 10,
                                                                                fontFamily: [
                                                                                    "Sarabun",
                                                                                    "Phetsarath"
                                                                                ],
                                                                                fontWeight: "bold"
                                                                            },
                                                                            children: [
                                                                                ele.cl_detail_discount ? "".concat(ele.cl_detail_discount, " ") : "",
                                                                                ((_row_SetPromotion = row.SetPromotion) === null || _row_SetPromotion === void 0 ? void 0 : _row_SetPromotion.set_promotion_type) == 1 ? "฿" : "%"
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Text, {
                                                                        style: styles.textRight,
                                                                        children: NumberFormatPDF(ele.cl_detail_price || 0)
                                                                    }, idx)
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                                                            children: /*#__PURE__*/ _jsx(Text, {
                                                                style: styles.textRight,
                                                                children: NumberFormatPDF(ele.cl_detail_price || 0)
                                                            }, idx)
                                                        }),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 80
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                return ele.cl_detail_wholesaledis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#b00312"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesaledis || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#999",
                                                                    textDecoration: "line-through"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesale || 0)
                                                        }, idx)
                                                    ]
                                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: NumberFormatPDF(ele.cl_detail_wholesale || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 80
                                                }
                                            ],
                                            children: row.ClDetail.map(function(ele, idx) {
                                                return ele.cl_detail_wholesalevatdis ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#b00312"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesalevatdis || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: [
                                                                styles.textRight,
                                                                {
                                                                    color: "#999",
                                                                    textDecoration: "line-through"
                                                                }
                                                            ],
                                                            children: NumberFormatPDF(ele.cl_detail_wholesalevat || 0)
                                                        }, idx)
                                                    ]
                                                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: NumberFormatPDF(ele.cl_detail_wholesalevat || 0)
                                                        }, idx),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            style: styles.textRight,
                                                            children: " "
                                                        }, idx)
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: [
                                                styles.cell,
                                                {
                                                    width: 120
                                                }
                                            ],
                                            children: row.SetPromotion ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(Text, {
                                                        style: styles.textCenter,
                                                        children: row.SetPromotion.set_promotion_name
                                                    }),
                                                    /*#__PURE__*/ _jsx(View, {
                                                        style: {
                                                            flexDirection: "row",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        },
                                                        children: row.SetPromotion.set_promotion_type == 3 && /*#__PURE__*/ _jsxs(_Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ _jsxs(Text, {
                                                                    style: [
                                                                        styles.textCenter,
                                                                        styles.textPromotionFree
                                                                    ],
                                                                    children: [
                                                                        row.SetPromotion.set_promotion_buy ? "".concat(row.SetPromotion.set_promotion_buy, " +") : "",
                                                                        row.SetPromotion.set_promotion_free ? "".concat(row.SetPromotion.set_promotion_free) : ""
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx(Text, {
                                                                    style: [
                                                                        styles.textCenter,
                                                                        styles.textPromotionWholesale
                                                                    ],
                                                                    children: row.ClDetail.map(function(ele, index) {
                                                                        return /*#__PURE__*/ _jsx(_Fragment, {
                                                                            children: ele.cl_detail_wholesaleavg ? /*#__PURE__*/ _jsx(_Fragment, {
                                                                                children: "ສະເລ່ຍຕໍ່ຊຸດ\n" + ele.cl_detail_wholesaleavg
                                                                            }) : ""
                                                                        });
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs(Text, {
                                                        style: styles.textCenter,
                                                        children: [
                                                            moment(row.SetPromotion.set_promotion_sdate).format("DD/MM/YYYY"),
                                                            " ",
                                                            "-",
                                                            " ",
                                                            moment(row.SetPromotion.set_promotion_edate).format("DD/MM/YYYY")
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ _jsx(Text, {
                                                style: styles.textCenter,
                                                children: "-"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, "".concat(row.cl_catalog_id || "catalog", "-").concat(i));
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fixed: true,
                    style: styles.pageNumber,
                    render: function(param) {
                        var pageNumber = param.pageNumber, totalPages = param.totalPages;
                        return "".concat(pageNumber, " / ").concat(totalPages);
                    }
                })
            ]
        })
    });
}
